import React, { useState, useEffect, useMemo, FC, useCallback } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { RootState } from "../../store/store";
import Content from "../../layout/content/Content";
import {
  Card,
  Badge,
  Row,
  Col,
  Button,
  Modal,
  ModalBody,
  Spinner,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
} from "reactstrap";
import Head from "../../layout/head/Head";
import {
  BlockBetween,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  Icon,
} from "../../components/Component";
import costCenterApis from "../../api/master/costCenter";
import departments from "../../api/master/departments";
import { FormProvider, useForm } from "react-hook-form";
import {
  PaperClipOutlined,
  DownloadOutlined,
  CheckCircleOutlined,
  CloseCircleOutlined,
  DeleteOutlined,
  EditOutlined,
  ExclamationCircleOutlined,
  InfoCircleOutlined,
} from "@ant-design/icons";
import {
  Form,
  TableColumnsType,
  Input,
  Table,
  Timeline,
  Collapse as AntCollapse,
  Descriptions,
  Modal as AntModal,
  Empty,
  Flex,
  Spin,
  DatePicker,
  Tooltip,
  Alert,
  Space,
} from "antd";
import ReactQuill from "react-quill";
import FormSelect from "../form-components/SelectComponent";
import FormInput from "../form-components/InputComponent";
import FormDatePicker from "../form-components/DatePicker";
import FormTextArea from "../form-components/TextAreaComponent";
import { Popover, Steps } from "antd";
import Swal from "sweetalert2";
import moment from "moment";
import rolesApi from "../../api/master/roles";
import dayjs from "dayjs";
import budgetApis from "../../api/master/budget";
import MaterialDrawer from "./EditBudgetMaterialDrawer";
import Dragger from "antd/es/upload/Dragger";
import Misc from "../masters/Misc";
import { UploadFile } from "antd/es/upload/interface";
import axios from "axios";
import { formatCurrency } from "../../utils/Utils";
import usersApis from "../../api/master/users";
import contractorsApis from "../../api/master/contractors";
import miscService from "../../api/misc/misc";
import supplierApis from "../../api/master/supplier";
import BulkBOMUploadDrawer from "./newBudgets/BulkBOMUploadDrawer";
import BudgetLineBulkUpload from "./newBudgets/BudgetLineBulkUpload";
import BudgetApprovalDrawer from "./newBudgets/BudgetApprovalDrawer";
import SignatureModal from "../purchase-orders/SignatureModal";
import ImageUploadCropper from "../components/ImageUploadCropper";

const { Panel } = AntCollapse;
const { beforeUpload } = Misc;

interface LineItem {
  lineId: number;
  budgetLineName: string;
  lineDescription: string;
  budgetValue: string;
  startDate: string;
  endDate: string;
  bom: string;
  allocation: string;
}

interface EventChain {
  id: number;
  orderNumber: number;
  orgId: number;
  eventType: string;
  eventName: string;
  error: string | null;
  eventDate: string;
  createdBy: number;
}

interface Item {
  orderNumber: number;
  referenceId: string;
  mode: string;
  version: number;
  orderDate: string;
  needByDateType: string;
  needByDate: string | null;
  orgId: number;
  siteId: number;
  supplierId: number;
  costCenterId: number;
  description: string;
  ledgerId: number;
  departmentId: number;
  budgetId: number;
  paymentTerms: string;
  advancePercentage: number;
  creditDays: number;
  paymentTermsDescription: string | null;
  inwardRequired: number;
  autoRelease: number;
  autoPoDoc: number;
  billingAddressId: number;
  deliveryAddressType: string;
  deliveryAddressId: string | null;
  currencyId: number;
  basicAmount: string;
  discount: string;
  netAmount: string;
  sgst: string;
  cgst: string;
  igst: string;
  additionalCharges: string;
  grossTotal: string;
  createdDate: string;
  createdBy: number;
  modifiedDate: string | null;
  modifiedBy: number | null;
  archieved: number;
  rejectedReason: string;
  approvalStatus: string;
  status: string;
  deliveryStatus: string;
  lineItems: LineItem[];
  eventChains: EventChain[];
  supplierName: string;
  siteName: string;
  costCenterName: string;
  createdUserName: string;
  createdUserId: number;
  currencyCode: string;
  currency: string;
  currencySymbol: string;
}

interface SelectOptions {
  label: string;
  value: string;
}

const ViewBudgetDetails: FC<any> = () => {
  const { data: currentUser } = useSelector((state: any) => state.currentUser);
  const [sm, setSm] = useState(false);
  const [tab, setTab] = useState("1");
  const [screenSize, setScreenSize] = useState(0);
  const [mobileView, setMobileView] = useState(false);
  const [instructionsVisible, setInstructionsVisible] = useState(false);
  const [termsVisible, setTermsVisible] = useState(false);
  const [materialData, setMaterialData] = useState<any>({});
  const [attachments, setAttachments] = useState<any>([]);
  const [roles, setRoles] = useState<any>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [actionStatus, setActionStatus] = useState("");
  const [showActionModelVisible, setShowActionModelVisible] = useState(false);
  const [costCenterOptions, setCostCenterOptions] = useState<SelectOptions[]>(
    []
  );
  const [form] = Form.useForm();
  const [showCommentsModal, setShowCommentsModal] = useState(false);
  const [sitesOptions, setSitesOptions] = useState<SelectOptions[]>([]);

  const [departmentOptions, setDepartmentOptions] = useState<SelectOptions[]>(
    []
  );
  const [materialCategoryOptions, setMaterialCategoryOptions] = useState([]);
  const [budgetCategoryOptions, setBudgetCategoryOptions] = useState<
    SelectOptions[]
  >([]);
  const [hasErrors, setHasErrors] = useState(false);
  const [DMS, setDMS] = useState<any>([]);
  const [editLineRow, setEditLineRow] = useState<any>();
  const [showSubmitBtm, setShowSubmitBtm] = useState(false);
  const [generalInformationEdit, setGeneralInformationEdit] = useState(false);
  const [activeEndDateEdit, setActiveEndDateEdit] = useState(false);
  const [extendForActivate, setExtendForActivate] = useState(false);
  const [approvals, setApprovals] = useState({
    open: false,
    data: [],
  });
  const navigate = useNavigate();
  const [deletedAttachments, setDeletedAttachments] = useState<any>([]);
  const [newAttachments, setNewAttachments] = useState<any>([]);
  const [newTermsAndConditions, setNewTermsAndConditions] = useState<any>("");
  const [instructions, setInstructions] = useState("");
  const [newInstructions, setNewInstructions] = useState<any>("");
  const [isTermsAndConditionsChanged, setIsTermsAndConditionsChanged] =
    useState(false);
  const [isInstructionsChanged, setIsInstructionsChanged] = useState(false);
  const [termsAndConditions, setTermsAndConditions] = useState<any>("");
  const [expandedRowKeys, setExpandedRowKeys] = useState<string[]>([]);
  const [currentBudgetLineForBulkUpload, setCurrentBudgetLineForBulkUpload] =
    useState<any>(null);
  const [disableSubmit, setDisableSubmit] = useState(false);
  const [disableSaveAsDraft, setDisableSaveAsDraft] = useState(false);
  const [contractorOptions, setContractorOptions] = useState<SelectOptions[]>(
    []
  );
  const [completedDateSelectedValue, setCompletedDateSelectedValue] =
    useState<any>("");

  const [signature, setSignature] = useState({
    isActive: false,
    label: "Authorised Signatory",
    image: null as string | null,
  });

  const [showSignatureModel, setShowSignatureModel] = useState(false);

  const [isModalApproveVisible, setIsModalApproveVisible] = useState(false);
  const [approveRecord, setApproveRecord] = useState<any>(null);
  const [activeSignatureContext, setActiveSignatureContext] = useState<
    "APPROVE" | "REJECT" | null
  >(null);

  const [isStrictMode, setIsStrictMode] = useState<boolean>(false);
  const [approverIds, setApproverIds] = useState<any>([]);

  const resetSignature = () => {
    setSignature({
      isActive: false,
      label: "Authorised Signatory",
      image: null,
    });
    setActiveSignatureContext(null);
  };

  const methods = useForm({
    mode: "onChange",
  });

  let { budgetId }: any = useParams();

  const [isModalRejectedVisible, setIsModalRejectedVisible] = useState(false);
  const [rejectRecord, setRejectRecord] = useState<any>(null);

  const {
    handleSubmit,
    reset,
    watch,
    setValue,
    formState: { errors },
  } = methods;
  const siteIdWatch = watch("site");
  const editStartDateWatch = watch("startDate");
  const modalEndDateWatch = watch("endDate");

  const [addNewRowModel, setAddNewRowModel] = useState<boolean>(false);
  const [data, setData] = useState<any>([]);
  const viewChange = () => {
    setScreenSize(window.innerWidth);
    if (window.innerWidth < 990) {
      setMobileView(true);
    } else {
      setMobileView(false);
      setSm(false);
    }
  };
  useEffect(() => {
    if (siteIdWatch) {
      fetchContractorList(siteIdWatch + "");
    }
  }, [siteIdWatch]);
  const handleExpand = (expanded: boolean, record: any) => {
    console.log("record", record);
    if (expanded) {
      setExpandedRowKeys([...expandedRowKeys, record.budgetLineName]);
    } else {
      setExpandedRowKeys(
        expandedRowKeys.filter((key) => key !== record.budgetLineName)
      );
    }
  };

  const fetchContractorList = async (siteId: any) => {
    try {
      const { data, status } = await contractorsApis.fetchContractorBySiteId({
        id: siteId,
      });
      if (status) {
        let contractorOptions = data.map((item: any) => ({
          label: item?.companyName,
          value: item?.contractorID?.toString(),
        }));
        setContractorOptions(contractorOptions);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const fetchBudgetDetails = async () => {
    try {
      const res = await budgetApis.fetchBudgetById(budgetId);
      const { response, status, message } = res;
      if (status) {
        let data: any = response;

        const isStrict =
          data?.isStrictApproval === true || data?.isStrictApproval === 1;

        setIsStrictMode(isStrict);

        if (data?.approvals) {
          const processedApprovals = data.approvals.map((approval: any) => ({
            ...approval,
            level: approval.level?.toLowerCase() || approval.level,
            status: approval.status?.toLowerCase() || approval.status
          }));
          data.approvals = processedApprovals;

          // Filter pending approvals
          let ids = processedApprovals
            ?.filter((item: any) => item?.status?.toLowerCase() !== "approved")
            ?.map((item: any) => item?.userId);
          setApproverIds(ids);
        }

        setIsLoading(false);
        setDMS(response.docs || []);
        const linesWithRowId = (response.lines || []).map((line: any) => ({
          ...line,
          _rowId:
            line.lineId != null
              ? `line_${line.lineId}`
              : `row_${Date.now()}_${Math.random().toString(36).slice(2, 9)}`,
        }));
        setMaterialData({ ...response, lines: linesWithRowId });
        console.log("response.lines", response.lines);
        console.log(
          "=== FETCH BUDGET DETAILS - SETTING DATA ===",
          linesWithRowId
        );
        setData(linesWithRowId);
        setHasErrors(false);
        setShowSubmitBtm(false);
        setDeletedAttachments([]);
        // Initialize approvals state from fetched data
        if (response.approvals && response.approvals.length > 0) {
          setApprovals({
            open: false,
            data: response.approvals,
          });
        }
        // setNewAttachments([]);
        const _attachments = response?.docs?.filter(
          (item: any) => item.moduleFileType == "Special Instructions"
        );
        console.log("_attachments", _attachments);
        if (_attachments) {
          console.log("_attachments", _attachments);
          setAttachments(
            _attachments.map((attachment: any) => ({
              docId: attachment.docId,
              name: attachment.fileName,
              link: attachment.filePath,
              moduleFileType: attachment.moduleFileType,
              module: attachment.module,
              label: "attachments",
              isActive: true,
            }))
          );
        }
        const _termsAndConditions = response?.docs?.find(
          (item: any) => item.moduleFileType == "termsAndConditions"
        );
        if (_termsAndConditions) {
          const data: any = await fetchHtmlContentFromUrl(
            _termsAndConditions?.filePath
          );
          setTermsAndConditions(data);
          setNewTermsAndConditions(data);
        }
        const _instructions = response?.docs?.find(
          (item: any) => item.moduleFileType == "instructions"
        );
        if (_instructions) {
          const data: any = await fetchHtmlContentFromUrl(
            _instructions?.filePath
          );
          setInstructions(data);
          setNewInstructions(data);
        }
      }
    } catch (error) {
      console.log(error);
    }
  };

  const parseLevelNum = (level: any) => {
    if (!level && level !== 0) return NaN;
    const str = String(level).toLowerCase();

    // Handle various level formats: level1, Level2, L1, L2, etc.
    if (str.includes('level')) {
      const match = str.match(/\d+/);
      return match ? parseInt(match[0], 10) : NaN;
    } else if (str.startsWith('l')) {
      const match = str.match(/\d+/);
      return match ? parseInt(match[0], 10) : NaN;
    }
    return NaN;
  };

  const hasUserAlreadyApproved = materialData?.approvals?.some(
    (a: any) =>
      a.userId === currentUser?.id &&
      a.status?.toUpperCase() === "APPROVED"
  );

  const canUserApproveReject = useCallback(() => {
    // 1. Admin can Approve/Reject anytime - Buttons are always ENABLED
    if (currentUser?.genericRole?.toLowerCase() === "admin") {
      return true;
    }

    const approvals = materialData?.approvals || [];

    // Find current user's approval entry
    const userApproval = approvals.find(
      (approval: any) => approval.userId === currentUser?.id
    );

    if (!userApproval || userApproval.status?.toLowerCase() !== "pending") {
      return false;
    }

    const userLevelNum = parseLevelNum(userApproval.level ?? currentUser?.approvalLevel);

    // 2. Strict = 0 (Flexible mode)
    // Anyone in the approval list can approve at any time
    if (isStrictMode === false) {
      // In flexible mode, just check if user is in the approval list and pending
      return true;
    }

    // 3. Strict = 1 (Sequential mode)
    // Must follow the order. Level 2 cannot see buttons until Level 1 is "Approved"
    if (isStrictMode === true) {
      // Get all pending approvals sorted by level
      const pendingApprovals = approvals
        .filter((approval: any) => approval.status?.toLowerCase() === "pending")
        .sort((a: any, b: any) => {
          const aNum = parseLevelNum(a.level);
          const bNum = parseLevelNum(b.level);
          if (isNaN(aNum) || isNaN(bNum)) return 0;
          return aNum - bNum;
        });

      // If there are no pending approvals, user can't approve
      if (pendingApprovals.length === 0) return false;

      // Get the first pending approval (lowest level)
      const firstPending = pendingApprovals[0];
      const firstPendingLevelNum = parseLevelNum(firstPending.level);

      // Check if user is the first pending approver
      return userApproval.userId === firstPending.userId &&
        userLevelNum === firstPendingLevelNum;
    }

    return false;
  }, [currentUser, currentUser?.id, materialData?.approvals, isStrictMode]);

  const getPendingStatusMessage = () => {
    const approvals = materialData?.approvals || [];
    const pendingApprovals = approvals
      .filter((approval: any) => approval.status?.toLowerCase() === "pending")
      .sort((a: any, b: any) => {
        const aNum = parseLevelNum(a.level);
        const bNum = parseLevelNum(b.level);
        if (isNaN(aNum) || isNaN(bNum)) return 0;
        return aNum - bNum;
      });

    if (pendingApprovals?.length > 0) {
      if (!isStrictMode) {
        // Flexible mode - any approver can approve
        const approverNames = pendingApprovals.map((approval: any) => approval.userName).join(", ");
        return `Status is pending. Any of these approvers can approve: ${approverNames}`;
      } else {
        // Strict mode - must follow sequence
        const nextApprover = pendingApprovals[0];
        const lvl = parseLevelNum(nextApprover.level);
        const levelText = !isNaN(lvl) ? `Level ${lvl}` : nextApprover.roleName || "";
        return `Status is pending. Waiting for ${nextApprover.userName} (${levelText}) to approve first.`;
      }
    }

    return "Status is pending by other approvers";
  };

  const fetchHtmlContentFromUrl = async (url: string) => {
    try {
      const response = await axios.get(url, {
        headers: {
          "Content-Type": "text/html",
        },
      });

      return response?.data;
    } catch (error) {
      console.log(error);
      return null;
    }
  };

  useEffect(() => {
    fetchBudgetDetails();
    viewChange();
    window.addEventListener("load", viewChange);
    window.addEventListener("resize", viewChange);
    const headerClick = () => setSm(false);
    document
      .getElementsByClassName("nk-header")[0]
      ?.addEventListener("click", headerClick);

    return () => {
      window.removeEventListener("resize", viewChange);
      window.removeEventListener("load", viewChange);
      document
        .getElementsByClassName("nk-header")[0]
        ?.removeEventListener("click", headerClick);
    };
  }, []);

  const fetchCostCenter = async () => {
    try {
      const { data, status, message } = await costCenterApis.fetchCostCenter();
      if (status) {
        let costCenterOptions = data.map((item: any) => {
          return { label: item.costCenterName, value: item.id.toString() };
        });
        setCostCenterOptions(costCenterOptions);
      }
    } catch (error) {
      console.log(error);
    }
  };
  const fetchSites = async () => {
    try {
      const data = await usersApis.getCurrentUser();
      if (data) {
        let sitesOptions = data?.siteAccessibility?.map((item: any) => ({
          label: item.siteName,
          value: item.siteID.toString(),
        }));
        setSitesOptions(sitesOptions);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const onValuesChange = (_: any, allValues: any) => {
    console.log("Form values changed: ", allValues); // Debugging - check form values
  };

  const fetchDepartment = async () => {
    try {
      const { data, status, message } = await departments.fetchDeptData();
      if (status) {
        let departmentOptions = data.map((item: any) => {
          return { label: item.deptName, value: item.deptID.toString() };
        });
        setDepartmentOptions(departmentOptions);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchModuleConfig();
    fetchCostCenter();
    fetchSites();
    fetchDepartment();
    fetchCategorys();
    fetchBudgetCategories();
  }, []);

  const columns = useMemo<TableColumnsType<Item>>(() => [
    // {
    //   ...Table.EXPAND_COLUMN,
    //   fixed: "left",
    // },
    {
      title: "Budget Line",
      dataIndex: "budgetLineName",
      key: "budgetLineName",
      fixed: "left" as const,
      width: 230,
    },
    {
      title: "Budget Line Description",
      dataIndex: "lineDescription",
      key: "lineDescription",
      // fixed: 'left' as const,
      width: 200,
    },
    {
      title: "Budget Category",
      dataIndex: "budgetCategoryName",
      key: "budgetCategoryName",
      width: 150,
      render: (text: any, record: any) => {
        // If budget category is "Others", show custom budget category, otherwise show budget category name
        if (text === "Others" && record.customBudgetCategory) {
          return record.customBudgetCategory;
        }
        return text || "Not Available";
      },
    },
    {
      title: "Budget For",
      dataIndex: "budgetFor",
      key: "budgetFor",
      width: 150,
      render: (text: any) => text || "Not Available",
    },
    {
      title: "Contractor",
      dataIndex: "contractorName",
      key: "contractorName",
      width: 150,
      render: (text: any) => text || "Not Available",
    },
    {
      title: "Budget Value",
      dataIndex: "budgetValue",
      key: "budgetValue",
      width: 150,
      render: (text: any, record: any) => {
        // Remove commas from the text before converting to a number
        const numericValue = Number(String(text).replace(/,/g, ""));

        return (
          <p className="justify-end">{formatCurrency(numericValue, "INR")}</p>
        );
      },
      // render: (text: any, record: any) => (
      //   <p className="justify-end">
      //     {formatCurrency(
      //       Number(text),
      //       "INR"
      //     )}
      //   </p>
      // ),
    },
    {
      title: "Planned Start Date",
      dataIndex: "startDate",
      key: "startDate",
      width: 170,
      render: (text) => moment(text).format("DD-MMM-YYYY"),
    },
    {
      title: "Planned End Date",
      dataIndex: "endDate",
      key: "endDate",
      width: 170,
      render: (text) => moment(text).format("DD-MMM-YYYY"),
    },
    {
      title: "Bill Of Material (BOM)",
      dataIndex: "bom",
      key: "bom",
      width: 220,
    },
    {
      title: "BOM Allocation",
      dataIndex: "allocation",
      key: "allocation",
      width: 220,
    },
    {
      title: "Department",
      dataIndex: "departmentName",
      key: "departmentName",
      width: 150,
    },
    {
      title: "Status",
      dataIndex: "errorFlag",
      key: "errorFlag",
      width: 80,
      align: "center" as const,
      render: (errorFlag: boolean, record: any) => {
        if (errorFlag && record.errorMessage) {
          const errorMessages = Array.isArray(record.errorMessage)
            ? record.errorMessage
            : [record.errorMessage];

          const tooltipContent = (
            <div style={{ maxWidth: 300 }}>
              <div
                style={{
                  fontWeight: "bold",
                  marginBottom: 8,
                  color: "#ff4d4f",
                }}
              >
                Validation Errors:
              </div>
              {errorMessages.map((error: string, index: number) => (
                <div key={index} style={{ marginBottom: 4 }}>
                  • {error}
                </div>
              ))}
            </div>
          );

          return (
            <Tooltip title={tooltipContent} placement="topLeft">
              <ExclamationCircleOutlined
                style={{
                  color: "#ff4d4f",
                  fontSize: 18,
                  cursor: "pointer",
                }}
              />
            </Tooltip>
          );
        }

        return (
          <>
            {record.lineStatus ? (
              record.lineStatus
            ) : (
              <Tooltip title="No validation errors">
                <CheckCircleOutlined
                  style={{
                    color: "#52c41a",
                    fontSize: 18,
                  }}
                />
              </Tooltip>
            )}
          </>
        );
      },
    },
    {
      title: "Actions",
      key: "actions",
      fixed: "right" as const,
      width: 120,
      render: (text, record: any, index) => {
        // Check if we should show edit based on status and lineStatus
        const shouldShowEdit = (() => {
          // If status is "Yet to be Approved", only show edit for PENDING lines
          if (materialData?.status === "Yet to be Approved" && materialData.isActive == true) {
            return record.lineStatus === "PENDING";
          }
          // If status is "Active", only show edit for new lines (lines without budgetLineId)
          if (materialData?.status === "Active") {
            // New lines don't have budgetLineId - they only have it after being saved to backend
            return !record.budgetLineId;
          }
          // For other statuses, always show edit
          return true;
        })();

        return (
          <Space size="small">
            {/* Show edit button based on conditions */}
            {shouldShowEdit && (
              <Button
                size="sm"
                color=""
                onClick={() => {
                  console.log("record", record);
                  setEditLineRow(record);
                }}
                title="Edit Budget Line"
              >
                <Icon name="edit" />
              </Button>
            )}

            {/* Show delete button only for lines with errors */}
            {record.errorFlag && (
              <Button
                size="sm"
                color=""
                onClick={() => {
                  Swal.fire({
                    title: "Are you sure?",
                    text: "Do you want to delete this budget line with errors?",
                    icon: "warning",
                    showCancelButton: true,
                    confirmButtonColor: "#d33",
                    cancelButtonColor: "#3085d6",
                    confirmButtonText: "Yes, delete it!",
                    cancelButtonText: "Cancel",
                  }).then((result) => {
                    if (result.isConfirmed) {
                      handleDeleteBudgetLine(record);
                    }
                  });
                }}
                title="Delete Budget Line"
              >
                <Icon name="trash" />
              </Button>
            )}
          </Space>
        );
      },
    },
  ], [materialData]);

  const filteredColumns = columns.filter((col) => {
    if (
      col.key == "actions" &&
      [
        "Rejected",
        "Inactive",
        "Completed",
        "Hold",
        "Manually Inactivated",
      ].includes(materialData?.status)
    ) {
      return false; // Filter out the "Action" column
    }
    return true; // Keep other columns
  });

  const handelExcelClick = () => {
    setShowCommentsModal(true);
  };

  const comments = async (comments: any) => {
    try {
      // return
      let apiResponse: any = {};
      apiResponse = await miscService.excelExportRequest({
        reportType: "Budget BOM",
        reportModule: "transactions",
        comments: comments,
        paginationData: {
          sortOrder: "DESC",
          pageSize: 10,
          direction: "P",
          pageDiff: 0,
          headerId: Number(budgetId),
        },
      });
      const { data, status } = apiResponse;
      if (status) {
        const { list, count } = data;
        Swal.fire({
          title: "Success",
          text: "Requested Submited Successfully",
          icon: "success",
        });
      }
    } catch (error) {
      console.error("Error loading data:", error);
    }
  };

  useEffect(() => {
    console.log("lines", editLineRow);
    if (editLineRow) {
      setAddNewRowModel(true);
    }
  }, [editLineRow]);

  // Check for errors whenever data changes
  useEffect(() => {
    console.log("=== DATA CHANGED ===");
    console.log("New data:", data);
    console.log("Data length:", data ? data.length : "null/undefined");

    if (data && Array.isArray(data)) {
      const hasErrorFlag = data.some((item: any) => item.errorFlag === true);
      setHasErrors(hasErrorFlag);
    }
  }, [data]);

  const fetchCategorys = async () => {
    try {
      const { data, status } = await supplierApis.fetchSupplierCategory();
      if (status) {
        const categoryOption = data.map((item: any) => ({
          label: item.category,
          value: item.id.toString(),
        }));
        setMaterialCategoryOptions(categoryOption);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const fetchBudgetCategories = async () => {
    try {
      const response = await budgetApis.fetchBudgetCategoryList();
      if (response.status) {
        const categories = response.response;
        if (Array.isArray(categories)) {
          const categoryOptions = categories.map((item: any) => ({
            label: item.budgetCategoryName,
            value: item.budgetCategoryId.toString(),
          }));
          setBudgetCategoryOptions(categoryOptions);
        }
      }
    } catch (error) {
      console.log("Error fetching budget categories:", error);
    }
  };

  const handleBulkBOMUpload = (
    uploadedBomLines: any[],
    budgetLineRecord: any
  ) => {
    console.log("Bulk BOM Upload for budget line:", budgetLineRecord);
    console.log("Uploaded BOM lines:", uploadedBomLines);

    // Update the budget line with new BOM lines
    const updatedData = data.map((item: any) => {
      if (item.budgetLineName === budgetLineRecord.budgetLineName) {
        return {
          ...item,
          bomLines: uploadedBomLines.map((bomLine: any, index: number) => ({
            id: `${item.budgetLineName}_bom_${index}`,
            boqContractorMaterialId: bomLine.boqContractorMaterialId || null,
            categoryId: bomLine.categoryId,
            categoryName: bomLine.categoryName,
            materialId: bomLine.materialId,
            materialName: bomLine.materialName,
            quantity: bomLine.quantity,
            uomId: bomLine.uomId,
            uomName: bomLine.uomName,
            allocated: bomLine.allocated,
            budgetAllocatedQty: bomLine.budgetAllocatedQty,
          })),
        };
      }
      return item;
    });

    setData(updatedData);

    // Also update materialData if needed
    setMaterialData((prevData: any) => ({
      ...prevData,
      budgetLines: updatedData,
    }));

    setCurrentBudgetLineForBulkUpload(null);
  };

  const handleBudgetLineBulkUpload = (uploadedBudgetLines: any[]) => {
    console.log("Bulk Budget Line Upload:", uploadedBudgetLines);

    // Add all uploaded budget lines to existing data. Use a fresh unique
    // `_rowId` for every uploaded line — a duplicate row shares its
    // budgetLineName with an existing line, so anything keyed on the name
    // collides and causes the existing line to be deleted alongside the
    // duplicate.
    const newBudgetLines = uploadedBudgetLines.map(
      (line: any, index: number) => ({
        ...line,
        _rowId: `bulk_${Date.now()}_${index}_${Math.random()
          .toString(36)
          .slice(2, 9)}`,
        // Don't add lineId for new bulk uploaded items - backend will assign it
        // lineId: line.lineId || Math.floor(Math.random() * 10000),
      })
    );

    // Update the data state
    const updatedData = [...data, ...newBudgetLines];
    setData(updatedData);

    // Check if any budget lines have errors
    const hasErrorFlag = newBudgetLines.some(
      (item: any) => item.errorFlag === true
    );
    const existingHasErrors = data.some((item: any) => item.errorFlag === true);
    setHasErrors(hasErrorFlag || existingHasErrors);

    // Update materialData lines
    setMaterialData((prevData: any) => ({
      ...prevData,
      lines: updatedData,
    }));

    setShowSubmitBtm(true);
  };

  const handleDeleteBudgetLine = (record: any) => {
    console.log("=== DELETE DEBUG ===");
    console.log("Record to delete:", record);

    // Match by the row's unique _rowId. budgetLineName is NOT unique when
    // a duplicate file is bulk-uploaded — the duplicate row and the original
    // existing row share the same name, so filtering by name would wipe both.
    const targetRowId = record?._rowId;

    setData((currentData: any[]) => {
      const updatedData = currentData.filter(
        (item: any) => item._rowId !== targetRowId
      );
      console.log("Data length before:", currentData.length, "after:", updatedData.length);
      return updatedData;
    });

    // Update materialData lines with functional update
    setMaterialData((prevData: any) => {
      const currentLines = prevData.lines || [];
      const updatedLines = currentLines.filter(
        (item: any) => item._rowId !== targetRowId
      );

      return {
        ...prevData,
        lines: updatedLines,
      };
    });

    // Check if there are still any errors after deletion using functional update
    setHasErrors((currentHasErrors: boolean) => {
      // We'll recalculate this in the data useEffect, so just maintain current state for now
      return currentHasErrors;
    });

    setShowSubmitBtm(true);

    Swal.fire({
      title: "Deleted!",
      text: "Budget line has been deleted successfully.",
      icon: "success",
      timer: 2000,
      showConfirmButton: false,
    });
  };

  const fetchApprovalHierarchyUsersByModuleId = async (moduleID: number) => {
    try {
      // const res = await rolesApi.fetchHierarchyUsersByModuleId(moduleID);
      // if (!res) return;
      // const { data, status } = res;
      // if (status) {
      //   setRoles(data);
      // }
    } catch (error) {
      console.log(error);
    }
  };
  const fetchModuleConfig = async () => {
    try {
      const res = await rolesApi.getModuleConfig();
      const moduleID = res?.data?.find(
        (x: any) => x.moduleName == "Purchase Order"
      )?.moduleID;
      console.log(moduleID);
      await fetchApprovalHierarchyUsersByModuleId(moduleID);
    } catch (err) {
      throw err;
    }
  };

  const ApprovalTimelineContent = () => {
    const approvalsData = materialData?.approvals;
    if (!approvalsData || approvalsData?.length === 0)
      return (
        <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
          <Badge color="outline-danger">No</Badge>
          {((materialData?.status === "Active") ||
            (materialData?.status === "Yet to be Approved" && materialData?.isActive === true)) && (
              <Tooltip title="Edit Approval Hierarchy">
                <EditOutlined
                  style={{ marginLeft: 8, cursor: "pointer" }}
                  onClick={(e) => {
                    e.stopPropagation();
                    setApprovals({
                      open: true,
                      data: materialData.approvals || [],
                    });
                  }}
                />
              </Tooltip>
            )}
        </div>
      );
    return (
      <Popover
        content={
          <Timeline className="approval-timeline">
            {approvalsData?.map((approval: any, index: number) => {
              const isApproved = approval.status?.toLowerCase() == "in_progress";
              const isRejected = approval.status?.toLowerCase() == "rejected";
              return (
                <Timeline.Item
                  key={index}
                  dot={
                    isApproved ? (
                      <CheckCircleOutlined style={{ color: "green" }} />
                    ) : isRejected ? (
                      <CloseCircleOutlined style={{ color: "red" }} />
                    ) : undefined
                  }
                >
                  {approval?.userName}
                  <div className="designation">{approval?.roleName}</div>
                  {approval?.approvalDate && (
                    <div className="designation">
                      {dayjs(approval?.approvalDate).format("DD-MMM-YYYY")}
                    </div>
                  )}
                </Timeline.Item>
              );
            })}
          </Timeline>
        }
        title={<span style={{ color: "#2263b3" }}>Approval Hierarchy</span>}
      >
        <div style={{
          display: "flex",
          alignItems: "center",
          gap: "8px",
          cursor: "pointer"
        }}>
          <span
            style={{
              color: "#2263b3",
              // textDecoration: "underline",
            }}
          >
            <Badge color="outline-success">Yes</Badge>
          </span>

          {/* Show edit icon for Active status or Yet to be Approved with isActive true when Approval Required = Y */}
          {((materialData?.status === "Active") ||
            (materialData?.status === "Yet to be Approved" && materialData?.isActive === true)) &&
            materialData?.approvalRequired === "Y" && (
              <Tooltip title="Edit Approval Hierarchy">
                <EditOutlined
                  style={{ marginLeft: 8, cursor: "pointer" }}
                  onClick={(e) => {
                    e.stopPropagation();
                    setApprovals({
                      open: true,
                      data: materialData.approvals || [],
                    });
                  }}
                />
              </Tooltip>
            )}

          {isStrictMode && (
            <Badge
              color="warning"
              style={{
                fontSize: "11px",
                cursor: "pointer",
                marginLeft: "4px"
              }}
              title="Sequential approvals required, Approvals must follow the sequence"
            >
              Strict
            </Badge>
          )}
        </div>
      </Popover>
    );
  };

  const append = (data: any) => {
    console.log("append", data);
    let newLineItems = materialData?.lines;
    const _data = newLineItems.find((item: any) => {
      if (item.budgetLineName == data.budgetLineName) return true;
    });

    if (_data) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Material Already Added",
      });
      return;
    }
    const newItem = {
      ...data,
      _rowId:
        data?._rowId ||
        `row_${Date.now()}_${Math.random().toString(36).slice(2, 9)}`,
    };
    setMaterialData((prev: any) => {
      let newData = {
        ...prev,
        lines: [...prev.lines, newItem], // Add new data to lines immutably
      };
      console.log(newData, "newData");
      return newData;
    });
    setData((pre: any) => {
      console.log("pre", pre);
      return [...pre, newItem];
    });
    setShowSubmitBtm(true);
  };

  // Update existing row handler
  const update = (id: any, data: any) => {
    console.log("update", data, id);
    let newLineItems = materialData?.lines;
    console.log("newLineItems", newLineItems);
    const _data = newLineItems
      .filter((item: any) => item.lineId != id)
      .find((item: any) => {
        if (
          item.budgetLineName == data.budgetLineName
          // &&
          // dayjs(item.needByDate).format("DD-MMM-YYYY") ==
          // dayjs(data.needByDate).format(
          //     "DD-MMM-YYYY"
          // ) &&
          // item.deliveryAddressId == data.deliveryAddressId
        )
          return true;
      });
    console.log("_dataaa", _data);
    if (_data) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: " Material Already Added",
      });
      return;
    }

    const updatedLines = newLineItems.map((item: any) => {
      if (item.lineId == id) {
        // Preserve the stable row identifier so the delete-by-_rowId path
        // continues to target only this row after edits.
        return { ...data, _rowId: item._rowId };
      }
      return item;
    });

    setMaterialData((prev: any) => ({
      ...prev,
      lines: updatedLines, // Update lines immutably
    }));

    setData(updatedLines);
    console.log("updatedLines", updatedLines);
    setShowSubmitBtm(true);
  };

  const onSubmit = async (data: any, tab: any) => {
    console.log("gendralINFO", data);
    const updatedResponse = {
      ...materialData, // Spread the existing response data
      ...data, // Spread the edited form data to overwrite the necessary fields
    };
    updatedResponse.siteName = sitesOptions.find(
      (site: any) => site.value == data.site
    )?.label;
    updatedResponse.contractorName = contractorOptions.find(
      (item) => item.value == data?.contractor
    )?.label;
    updatedResponse.departmentName = departmentOptions.find(
      (department: any) => department.value == parseInt(data.department)
    )?.label;
    updatedResponse.costCenterName = costCenterOptions.find(
      (costCenter: any) => costCenter.value == parseInt(data.costCenter)
    )?.label;
    console.log("updatedResponse", updatedResponse);
    setMaterialData(updatedResponse);
    setGeneralInformationEdit(false);
  };

  const updateBudgetLines = (data: any) => {
    console.log("updateBudgetLines", data);
    setMaterialData((prevData: any) => {
      let newData = { ...prevData };
      newData?.budgetLines?.push(data);
      return newData;
    });
    setData((prevData: any) => [...prevData, data]);
    console.log("materialData", materialData, data);
  };

  const handleAttachmentChange = (info: { fileList: UploadFile[] }) => {
    setNewAttachments((pre: any) => {
      return [...pre, ...info.fileList];
    });
    setShowSubmitBtm(true);
  };

  const submitSave = (statusOverride?: string, headerOverrides?: any) => {
    const deletedFileData: any = [...deletedAttachments];
    const newfiledata: any = [];
    console.log("DMS", DMS);
    const formDataToSend = new FormData();
    console.log("newAttachments", newAttachments);
    // Map the new attachments to the desired format
    newAttachments.forEach((attachment: any, index: number) => {
      if (!attachment) {
        return;
      }
      const file = attachment?.originFileObj;
      formDataToSend.append("files", file);
      newfiledata.push({
        fileIndex: newfiledata.length, // Continue the index after existing attachments
        module: "Budget",
        moduleFileType: "Special Instructions", // Adjust as necessary
        level: "HEADER_LEVEL", // Adjust as necessary
        // budgetId: BudgetData.budgetId, // Assuming you have access to BudgetData
      });
    });

    // console.log("Lines:", lines);
    // console.log("Docs:", docs);
    // console.log("Approvals:", approvals);
    // console.log("Remaining Data:", remainingData);

    if (isInstructionsChanged) {
      const instructionsFile = new Blob([newInstructions], {
        type: "text/html",
      });
      formDataToSend.append(
        `files`,
        new File([instructionsFile], "instructions.html", {
          type: "text/html",
        })
      );
      newfiledata.push({
        fileIndex: newfiledata.length,
        module: "Budget",
        moduleFileType: "instructions",
        level: "HEADER_LEVEL",
      });
      setIsInstructionsChanged(false);
      const _instructions = DMS?.find(
        (item: any) => item.moduleFileType == "instructions"
      );
      if (_instructions?.docId) {
        deletedAttachments.push({
          docId: _instructions.docId,
        });
      }
    }
    if (isTermsAndConditionsChanged) {
      console.log("isTermsAndConditionsChanged");
      const termsAndConditionsFile = new Blob([newTermsAndConditions], {
        type: "text/html",
      });
      formDataToSend.append(
        `files`,
        new File([termsAndConditionsFile], "termsAndConditions.html", {
          type: "text/html",
        })
      );
      newfiledata.push({
        fileIndex: newfiledata.length,
        module: "Budget",
        moduleFileType: "termsAndConditions",
        level: "HEADER_LEVEL",
      });
      setIsTermsAndConditionsChanged(false);
      const _termsAndConditions = DMS?.find(
        (item: any) => item.moduleFileType == "termsAndConditions"
      );
      if (_termsAndConditions?.docId) {
        console.log("deletedDocIds", _termsAndConditions.docId);
        deletedAttachments.push({
          docId: _termsAndConditions.docId,
        });
      }
    }

    console.log("deletedFileData", deletedFileData);

    materialData.docs = [...materialData.docs, ...newfiledata];
    console.log("updatedDocs", materialData.docs);

    const {
      lines,
      docs,
      approvals: originalApprovals,
      ...remainingData
    } = materialData;

    // If statusOverride is provided, use it; otherwise keep the existing status
    if (statusOverride) {
      remainingData.status = statusOverride;
    }

    // Merge any header-level overrides (e.g. extended endDate for activation)
    if (headerOverrides) {
      Object.assign(remainingData, headerOverrides);
    }

    // Use the updated approvals from state if available, otherwise use original
    const approvalsToSubmit =
      approvals.data.length > 0 ? approvals.data : originalApprovals;

    remainingData.approvalRequired =
      approvalsToSubmit && approvalsToSubmit.length > 0 ? "Y" : "N";

    remainingData.isStrictApproval = isStrictMode ? 1 : 0;
    remainingData.site = Number(remainingData?.site);
    remainingData.endDate = dayjs(remainingData.endDate).format("YYYY-MM-DD");
    remainingData.startDate = dayjs(remainingData.startDate).format(
      "YYYY-MM-DD"
    );
    remainingData.currencyCode = "INR";
    remainingData.contractor = remainingData?.contractor
      ? Number(remainingData?.contractor)
      : null;
    remainingData.budgetValue =
      typeof remainingData?.budgetValue === "string"
        ? Number(remainingData?.budgetValue.replace(/,/g, ""))
        : Number(remainingData?.budgetValue);
    lines?.forEach((line: any) => {
      console.log("line:;;;1", line);
      line.budgetValue =
        typeof line?.budgetValue === "string"
          ? Number(line.budgetValue.replace(/,/g, ""))
          : Number(line?.budgetValue);
      line.startDate = dayjs(line?.startDate).format("YYYY-MM-DD");
      line.endDate = dayjs(line?.endDate).format("YYYY-MM-DD");

      // Remove lineId for new items only
      // New items are identified by having a key property but no budgetLineId
      // Existing items will have budgetLineId from the backend
      if (!line.budgetLineId && line.key) {
        delete line.lineId;
      }

      line.bomLines?.forEach((bomLine: any) => {
        // Check if allocated is a string and contains commas, then replace them
        bomLine.allocated =
          typeof bomLine?.allocated === "string"
            ? Number(bomLine.allocated.replace(/,/g, ""))
            : Number(bomLine?.allocated);

        // Check if quantity is a string and contains commas, then replace them
        bomLine.quantity =
          typeof bomLine?.quantity === "string"
            ? Number(bomLine.quantity.replace(/,/g, ""))
            : Number(bomLine?.quantity);

        // Check if budgetAllocatedQty is a string and contains commas, then replace them
        if (bomLine?.budgetAllocatedQty !== undefined) {
          bomLine.budgetAllocatedQty =
            typeof bomLine?.budgetAllocatedQty === "string"
              ? Number(bomLine.budgetAllocatedQty.replace(/,/g, ""))
              : Number(bomLine?.budgetAllocatedQty);
        }
      });
    });
    const submissionData = {
      header: remainingData,
      lines: lines,
      approvals: approvalsToSubmit,
      docKeys: docs,
    };
    console.log(
      "submissionData:::",
      submissionData,
      remainingData.endDate,
      remainingData.startDate
    );
    // return;
    formDataToSend.append("header", JSON.stringify(submissionData.header));
    formDataToSend.append("lines", JSON.stringify(submissionData.lines));
    formDataToSend.append(
      "approvals",
      JSON.stringify(submissionData.approvals)
    );
    formDataToSend.append("docKeys", JSON.stringify(submissionData.docKeys));
    const deletedDocIds = deletedAttachments.map(
      (deleted: any) => deleted.docId
    );
    console.log("deletedDocIds", deletedDocIds);
    formDataToSend.append(
      "deletedId",
      JSON.stringify(deletedDocIds.length > 0 ? deletedDocIds : [])
    );
    // newAttachments.forEach((attachment: any) => {
    //   const file = new File([attachment], attachment.name, {
    //     type: attachment.type,
    //     lastModified: attachment.lastModified,
    //   });
    //   formDataToSend.append("files1111", file);
    // });
    console.log("formDataToSend", formDataToSend);
    // addRow(data);
    BudgetCreation(formDataToSend, statusOverride === "DRAFT");
  };

  const BudgetCreation = async (data: any, isDraft: boolean = false) => {
    console.log("data", data);
    // return;
    try {
      const dataAPI: any = await budgetApis.createNewVersionBudget(data);
      console.log(dataAPI);
      const { status, message, response } = dataAPI;
      if (status) {
        if (isDraft) {
          Swal.fire("Saved as Draft!", response?.budgetId, "success");
        } else {
          Swal.fire("Updated!", response?.budgetId, "success");
        }
        navigate(`/view-budget`);
        fetchBudgetDetails();
      } else {
        Swal.fire("Failed!", message, "error");
      }
    } catch (error) {
      Swal.fire("Failed!", "Something went wrong", "error");
    }
    setDisableSubmit(false);
    setDisableSaveAsDraft(false);
  };

  const hold = async () => {
    setActionStatus("Hold");
    setShowActionModelVisible(true);
  };

  const complete = async () => {
    setActionStatus("Complete");
    setShowActionModelVisible(true);
  };

  const inactive = async () => {
    setActionStatus("Inactive");
    setShowActionModelVisible(true);
  };

  const handleActivate = () => {
    setExtendForActivate(true);
    setValue("endDate", dayjs(materialData?.endDate));
    setActiveEndDateEdit(true);
  };

  const handleCancel = () => {
    setShowActionModelVisible(false);
    setIsModalRejectedVisible(false);
    form.resetFields();
  };

  const apiCallToHoldBudget = async (headerId: any, reason: string) => {
    // Replace this with your actual API call logic
    try {
      let data = {
        headerId: Number(headerId),
        remarks: reason,
      };
      const res = await budgetApis.holdBudget(data);
      const { response, status, message } = res;
      console.log("data", response);
      if (res.status) {
        Swal.fire("Hold!", "Budget has been Hold", "success");
        fetchBudgetDetails();
      } else {
        Swal.fire("Failed!", message, "error");
      }
    } catch (error) {
      Swal.fire("Failed!", "Something went wrong", "error");
    }
  };

  const apiCallToInactiveBudget = async (headerId: any, reason: string) => {
    // Replace this with your actual API call logic
    try {
      let data = {
        headerId: Number(headerId),
        remarks: reason,
      };
      const res = await budgetApis.inactivateBudget(data);
      const { response, status, message } = res;
      console.log("data", response);
      if (res.status) {
        Swal.fire("Inactive!", "Budget has been Inactive", "success");
        fetchBudgetDetails();
      } else {
        Swal.fire("Failed!", message, "error");
      }
    } catch (error) {
      Swal.fire("Failed!", "Something went wrong", "error");
    }
  };

  const apiCallToCompleteBudget = async (
    headerId: any,
    reason: string,
    date: any
  ) => {
    // Replace this with your actual API call logic
    try {
      let data = {
        headerId: Number(headerId),
        remarks: reason,
        completedDate: dayjs(date).format("YYYY-MM-DD"),
      };
      const res = await budgetApis.completeBudget(data);
      const { response, status, message } = res;
      console.log("data", response);
      if (res.status) {
        Swal.fire("Completed!", "Budget is marked as Completed", "success");
        fetchBudgetDetails();
      } else {
        Swal.fire("Failed!", message, "error");
      }
    } catch (error) {
      Swal.fire("Failed!", "Something went wrong", "error");
    }
  };

  const handleOk = async () => {
    console.log("11111");
    if (actionStatus === "Hold") {
      console.log("HOLD", actionStatus);
      try {
        const values = await form.validateFields();
        await apiCallToHoldBudget(budgetId, values.reason);
        setShowActionModelVisible(false);
        form.resetFields();
      } catch (error) { }
    }
    if (actionStatus === "Inactive") {
      console.log("Inactive", actionStatus);
      try {
        const values = await form.validateFields();
        await apiCallToInactiveBudget(budgetId, values.inActiveReason);
        setShowActionModelVisible(false);
        form.resetFields();
      } catch (error) { }
    }
    if (actionStatus === "Complete") {
      console.log("actionStatus", actionStatus);
      const values = await form.validateFields(); // Validate all fields
      console.log("values", values);
      console.log(
        "Completion Date:",
        dayjs(values.completionDate).format("DD-MMM-YYYY")
      );
      console.log("Reason for Delay:", values.reasonForDelay);
      try {
        const values = await form.validateFields();
        await apiCallToCompleteBudget(
          budgetId,
          values.reasonForDelay,
          dayjs(values.completionDate).format("DD-MMM-YYYY")
        );
        setShowActionModelVisible(false);
        form.resetFields();
      } catch (error) { }
    }
  };

  const handleApprove = async (id: string, files: File[] = []) => {
    try {
      const res = await budgetApis.approveBudget(Number(id), files);
      const { response, status, message } = res;
      console.log("data", res);
      if (status) {
        Swal.fire("Approved!", "Budget has been Approved", "success");
        resetSignature();
        navigate(-1);
      } else {
        Swal.fire("Failed!", message, "error");
        resetSignature();
      }
    } catch (error) {
      Swal.fire("Failed!", "Something went wrong", "error");
      resetSignature();
    }
  };

  // Check if current user is in the approvals list
  const isCurrentUserApprover = () => {
    console.log("currentUser", currentUser);
    if (!currentUser || !materialData?.approvals) return false;
    return materialData.approvals.some(
      (approval: any) => approval.userId === currentUser.id
    );
  };

  const apiCallToRejectBudget = async (headerId: any, reason: string) => {
    const files: File[] = [];
    if (signature.image) {
      files.push(dataURLToFile(signature.image as string, "signature.png"));
    }
    // Replace this with your actual API call logic
    try {
      const res = await budgetApis.rejectBudget(headerId, reason, files);
      const { response, status, message } = res;
      console.log("data", response);
      if (res.status) {
        Swal.fire("Rejected!", "Budget has been Rejected", "success");
        resetSignature();
        navigate(-1);
      } else {
        Swal.fire("Failed!", message, "error");
        resetSignature();
      }
    } catch (error) {
      Swal.fire("Failed!", "Something went wrong", "error");
      resetSignature();
    }
  };

  const dataURLToFile = (dataUrl: string, fileName: string): File => {
    const arr = dataUrl.split(",");
    const mimeMatch = arr[0].match(/:(.*?);/);
    const mime = mimeMatch ? mimeMatch[1] : "image/png";
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    return new File([u8arr], fileName, { type: mime });
  };

  const openApproveConfirmSwal = () => {
    if (!signature.image) return;

    setIsModalApproveVisible(false);

    Swal.fire({
      title: "Are you sure?",
      text: "You will not be able to recover this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, Approve it!",
      cancelButtonText: "No, keep it",
      allowOutsideClick: false,
      allowEscapeKey: false,
    }).then(async (result) => {
      if (result.isConfirmed) {
        const file = dataURLToFile(signature.image as string, "signature.png");
        await handleApprove(approveRecord, [file]);
      } else {
        setIsModalApproveVisible(true);
      }
    });
  };

  const openRejectConfirmSwal = async () => {
    await form.validateFields();

    if (!signature.image) {
      Swal.fire({
        icon: "info",
        title: "Signature Required",
        text: "Please add your signature before rejecting.",
      });
      return;
    }

    setIsModalRejectedVisible(false);

    Swal.fire({
      title: "Confirm Rejection?",
      text: "This action cannot be undone!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, Reject it!",
      cancelButtonText: "Cancel",
      allowOutsideClick: false,
      allowEscapeKey: false,
    }).then(async (result) => {
      if (result.isConfirmed) {
        const values = form.getFieldsValue();
        await apiCallToRejectBudget(rejectRecord, values.reason);
      } else {
        setIsModalRejectedVisible(true);
      }
    });
  };

  return (
    <>
      <Head title="Budget - Track" />
      <Modal
        isOpen={generalInformationEdit}
        toggle={() => setGeneralInformationEdit(false)}
        className="modal-dialog-centered"
        size="xl"
        backdrop="static"
      >
        <a
          href="#cancel"
          onClick={(ev) => {
            ev.preventDefault();
            setGeneralInformationEdit(false);
          }}
          className="close"
        >
          <Icon name="cross-sm"></Icon>
        </a>

        <ModalBody>
          {/* {tab === "1" && ( */}
          <>
            <h5 className="title">Update General Information</h5>
            <div style={{ marginTop: "15px" }}></div>

            <FormProvider {...methods}>
              <form
                className="content clearfix"
                onSubmit={handleSubmit((data) => {
                  onSubmit(data, 1);
                  setShowSubmitBtm(true);
                })}
              >
                <Row className="gy-4">
                  <Col lg="4">
                    <FormInput
                      name="budgetName"
                      label="Budget Name"
                      required={true}
                      placeholder="Enter Budget Name"
                    />
                  </Col>
                  <Col lg="4">
                    <FormDatePicker
                      name="startDate"
                      label="Planned Start Date"
                      required={true}
                    />
                  </Col>
                  <Col lg="4">
                    <FormDatePicker
                      name="endDate"
                      label="Planned End Date"
                      required={true}
                      minDate={editStartDateWatch}
                      disabled={!editStartDateWatch}
                    />
                  </Col>
                  <Col lg="12">
                    <FormTextArea
                      name="description"
                      label="Budget Description"
                      required={true}
                      placeholder="Enter Budget Description"
                      maxLength={500}
                    />
                  </Col>
                  <Col lg="3">
                    <FormSelect
                      name="budgetFor"
                      label="Budget for"
                      options={[
                        { label: "Site Procurement", value: "Procurement" },
                        { label: "Site Operations", value: "Operations" },
                      ]}
                      required={true}
                      placeholder="Select"
                    />
                  </Col>
                  <Col lg="3">
                    <FormSelect
                      name="site"
                      label="Select Site"
                      options={sitesOptions}
                      required={true}
                      placeholder="Select"
                    />
                  </Col>
                  <Col lg="3">
                    <FormSelect
                      name="contractor"
                      label={`Contractor`}
                      options={contractorOptions}
                      placeholder="-Select-"
                      disabled={true}
                      tooltipText="Select the contractor for this purchase order."
                    />
                  </Col>
                  <Col lg="3">
                    <FormSelect
                      name="lob"
                      label="Select Line Of Business (LOB)"
                      defaultValue={{
                        label: "Construction",
                        value: "Construction",
                      }}
                      options={[
                        { label: "Construction", value: "Construction" },
                        { label: "Others", value: "Others" },
                      ]}
                      required={true}
                      placeholder="Select"
                    />
                  </Col>
                  <Col lg="3">
                    <FormSelect
                      name="costCenter"
                      label="Cost Center"
                      options={costCenterOptions}
                      required={false}
                      placeholder="Select"
                    />
                  </Col>

                  {/* <Col lg="3">
                    <FormSelect
                      name="approvalRequired"
                      label="Approval Required ?"
                      options={[
                        { label: "Yes", value: "Y" },
                        { label: "No", value: "N" },
                      ]}
                      placeholder="Select"
                      required={true}
                    />
                    <div style={{ display: "none" }}>
                      <FormInput name="approvalsData" label="" type="text" noMaxLength />
                    </div>
                    {watch("approvalRequired") == "Y" && (
                      <Popover
                        content="Click here to set required approvals"
                        title="Approval Required"
                      >
                        <a
                          href="#"
                          className="success"
                          onClick={(e) => {
                            e.preventDefault();
                            setApprovals((pre) => {
                              return {
                                ...pre,
                                open: true,
                              };
                            });
                          }}
                        >
                          <EditOutlined /> Set Approvals &nbsp;
                          {approvals?.data?.length == 0 ? (
                            <span className="mandatory">
                              Please set approvals
                            </span>
                          ) : (
                            <></>
                          )}
                        </a>
                      </Popover>
                    )}
                  </Col>
                  <Col lg="3">
                    <FormSelect
                      name="docRequired"
                      label="Require Documents?"
                      options={[
                        { label: "Yes", value: "Y" },
                        { label: "No", value: "N" },
                      ]}
                      required={false}
                      placeholder="Select"
                      // onChange={(val) =>
                      //   updateFormState({ showAskDocs: val === "Y" })
                      // }
                    />
                    {formState.showAskDocs && (
                      <Popover
                        content="Click here to ask required documents"
                        title="Documents Required"
                      >
                        <a
                          href="#"
                          className="success"
                          onClick={(e) => {
                            e.preventDefault();
                            showAskDocumentsDrawer();
                          }}
                        >
                          <EditOutlined /> Ask Required Documents &nbsp;
                          {formState.documentsPopoverVisible ? (
                            <span className="mandatory">
                              Please set documents
                            </span>
                          ) : (
                            <></>
                          )}
                        </a>
                      </Popover>
                    )}
                  </Col> */}
                </Row>
                <Row className="mt-4">
                  <Col lg="12">
                    <ul className="align-center flex-wrap flex-sm-nowrap gx-4 gy-2">
                      <li>
                        <Button
                          className="btn btn-primary btn-md"
                          type="submit"
                          color="primary"
                        >
                          Save
                        </Button>
                      </li>
                      <li>
                        <a
                          href="#cancel"
                          onClick={(ev) => {
                            ev.preventDefault();
                            setGeneralInformationEdit(false);
                            reset();
                          }}
                          className="link link-light"
                        >
                          Cancel
                        </a>
                      </li>
                    </ul>
                  </Col>
                </Row>
              </form>
            </FormProvider>
          </>
          {/* )} */}
        </ModalBody>
      </Modal>

      {/* Modal for Active status - Only End Date editing */}
      <Modal
        isOpen={activeEndDateEdit}
        toggle={() => setActiveEndDateEdit(false)}
        className="modal-dialog-centered"
        size="md"
        backdrop="static"
      >
        <a
          href="#cancel"
          onClick={(ev) => {
            ev.preventDefault();
            setActiveEndDateEdit(false);
          }}
          className="close"
        >
          <Icon name="cross-sm"></Icon>
        </a>

        <ModalBody>
          <h5 className="title">
            {extendForActivate ? "Activate Budget" : "Update Planned End Date"}
          </h5>
          {extendForActivate &&
            dayjs(materialData?.endDate).isBefore(dayjs(), "day") && (
              <Alert
                message="Planned End Date has already passed. Please extend it before activating this budget."
                type="warning"
                showIcon
                style={{ marginTop: 12, marginBottom: 4 }}
              />
            )}
          <div style={{ marginTop: "15px" }}></div>

          <FormProvider {...methods}>
            <form
              className="content clearfix"
              onSubmit={handleSubmit((data) => {
                // Only update end date
                const updatedData = {
                  ...materialData,
                  endDate: data.endDate,
                };
                setMaterialData(updatedData);
                setActiveEndDateEdit(false);
                if (extendForActivate) {
                  submitSave("IN_PROGRESS", { endDate: data.endDate });
                } else {
                  setShowSubmitBtm(true);
                }
              })}
            >
              <Row className="gy-4">
                <Col lg="12">
                  <FormDatePicker
                    name="endDate"
                    label="Planned End Date"
                    placeholder="Select Planned End Date"
                    required={true}
                    minDate={
                      extendForActivate
                        ? new Date()
                        : new Date(materialData?.startDate)
                    }
                  />
                </Col>
              </Row>

              <Row className="mt-4">
                <Col size="12">
                  <ul className="align-center flex-wrap flex-sm-nowrap gx-4 gy-2">
                    <li>
                      <Button
                        className="btn btn-primary"
                        color="primary"
                        disabled={
                          extendForActivate &&
                          (!modalEndDateWatch ||
                            dayjs(modalEndDateWatch).isBefore(dayjs(), "day"))
                        }
                      >
                        <span>{extendForActivate ? "Activate Budget" : "Update"}</span>
                      </Button>
                    </li>
                    <li>
                      <a
                        href="#cancel"
                        onClick={(ev) => {
                          ev.preventDefault();
                          setActiveEndDateEdit(false);
                        }}
                        className="link link-light"
                      >
                        Cancel
                      </a>
                    </li>
                  </ul>
                </Col>
              </Row>
            </form>
          </FormProvider>
        </ModalBody>
      </Modal>

      <Content>
        <Card className="card-bordered">
          <div className="card-aside-wrap">
            {isLoading == true ? (
              <>
                <Flex align="center" gap="middle" className="pageLoader">
                  <Spin size="large" className="m-auto" />
                </Flex>
              </>
            ) : (
              <div className="card-inner card-inner-lg">
                {sm && mobileView && (
                  <div
                    className="toggle-overlay"
                    onClick={() => setSm(!sm)}
                  ></div>
                )}
                <BlockHead size="lg">
                  <BlockBetween>
                    <BlockHeadContent>
                      <BlockTitle tag="h4">
                        <span>
                          Budget ID - {materialData?.budgetId} |{" "}
                          {materialData?.status}
                          {/* {(statusMapper[rfqStatus] &&
                              statusMapper[rfqStatus]?.buyer?.title) ||
                              rfqStatus}{" "} */}
                        </span>
                      </BlockTitle>
                    </BlockHeadContent>
                    <div className="d-flex">
                      {(showSubmitBtm || materialData?.status === "Draft") && (
                        <div className="actions clearfix">
                          <ul
                            className="m-auto d-flex align-items-center justify-content-center p-0"
                            style={{
                              flexDirection: "row-reverse",
                            }}
                          >
                            {materialData?.status === "Draft" ? (
                              <>
                                {/* Submit Button for Draft Status */}
                                <li className="pt-0 pb-0">
                                  {disableSubmit ? (
                                    <Button color="primary" type="button">
                                      <Spinner size="sm" color="light" />
                                    </Button>
                                  ) : (
                                    <Button
                                      color="primary"
                                      type="button"
                                      disabled={hasErrors}
                                      title={
                                        hasErrors
                                          ? "Please fix all errors before submitting"
                                          : ""
                                      }
                                      onClick={() => {
                                        setDisableSubmit(true);
                                        Swal.fire({
                                          title: "Are you sure?",
                                          text: "Do you want to submit this budget for approval?",
                                          icon: "warning",
                                          showCancelButton: true,
                                          confirmButtonColor: "#3085d6",
                                          cancelButtonColor: "#d33",
                                          confirmButtonText: "Yes, submit it!",
                                          cancelButtonText: "No, cancel",
                                        }).then(async (result) => {
                                          if (result.isConfirmed) {
                                            await submitSave("PENDING");
                                          } else {
                                            setDisableSubmit(false);
                                          }
                                        });
                                      }}
                                    >
                                      Submit
                                    </Button>
                                  )}
                                </li>
                                {/* Save as Draft Button for Draft Status */}
                                <li className="pt-0 pb-0">
                                  {disableSaveAsDraft ? (
                                    <Button color="secondary" type="button">
                                      <Spinner size="sm" color="light" />
                                    </Button>
                                  ) : (
                                    <Button
                                      color="secondary"
                                      type="button"
                                      disabled={hasErrors}
                                      title={
                                        hasErrors
                                          ? "Please fix all errors before saving"
                                          : ""
                                      }
                                      onClick={() => {
                                        setDisableSaveAsDraft(true);
                                        Swal.fire({
                                          title: "Are you sure?",
                                          text: "Do you want to save the changes as draft?",
                                          icon: "warning",
                                          showCancelButton: true,
                                          confirmButtonColor: "#3085d6",
                                          cancelButtonColor: "#d33",
                                          confirmButtonText: "Yes, save it!",
                                          cancelButtonText: "No, cancel",
                                        }).then(async (result) => {
                                          if (result.isConfirmed) {
                                            await submitSave("DRAFT");
                                          } else {
                                            setDisableSaveAsDraft(false);
                                          }
                                        });
                                      }}
                                    >
                                      Save as Draft
                                    </Button>
                                  )}
                                </li>
                                {/* Revert Changes Button for Draft Status - only show if changes were made */}
                                {showSubmitBtm && (
                                  <li className="pt-0 pb-0">
                                    <Button
                                      color="secondary"
                                      onClick={() => {
                                        Swal.fire({
                                          title: "Are you sure?",
                                          text: "Do you want to revert the changes?",
                                          icon: "warning",
                                          showCancelButton: true,
                                          confirmButtonColor: "#3085d6",
                                          cancelButtonColor: "#d33",
                                          confirmButtonText: "Yes, revert it!",
                                          cancelButtonText: "No, cancel",
                                        }).then((result) => {
                                          if (result.isConfirmed) {
                                            fetchBudgetDetails();
                                            Swal.fire(
                                              "Reverted!",
                                              "Your changes have been reverted.",
                                              "success"
                                            );
                                          }
                                        });
                                      }}
                                      type="button"
                                      className="btn-dim btn btn-secondary"
                                    >
                                      Revert Changes
                                    </Button>
                                  </li>
                                )}
                              </>
                            ) : (
                              <>
                                {/* Save Changes Button for Non-Draft Status */}
                                <li className="pt-0 pb-0">
                                  {disableSubmit ? (
                                    <Button color="primary" type="button">
                                      <Spinner size="sm" color="light" />
                                    </Button>
                                  ) : (
                                    <Button
                                      color="primary"
                                      type="button"
                                      disabled={hasErrors}
                                      title={
                                        hasErrors
                                          ? "Please fix all errors before saving changes"
                                          : ""
                                      }
                                      onClick={() => {
                                        setDisableSubmit(true);
                                        Swal.fire({
                                          title: "Are you sure?",
                                          text: "Do you want to submit the changes?",
                                          icon: "warning",
                                          showCancelButton: true,
                                          confirmButtonColor: "#3085d6",
                                          cancelButtonColor: "#d33",
                                          confirmButtonText: "Yes, submit it!",
                                          cancelButtonText: "No, cancel",
                                        }).then(async (result) => {
                                          if (result.isConfirmed) {
                                            await submitSave();
                                          } else {
                                            setDisableSubmit(false);
                                          }
                                        });
                                      }}
                                    >
                                      Save Changes
                                    </Button>
                                  )}
                                </li>
                                {/* Revert Changes Button for Non-Draft Status */}
                                <li className="pt-0 pb-0">
                                  <Button
                                    color="secondary"
                                    onClick={() => {
                                      Swal.fire({
                                        title: "Are you sure?",
                                        text: "Do you want to revert the changes?",
                                        icon: "warning",
                                        showCancelButton: true,
                                        confirmButtonColor: "#3085d6",
                                        cancelButtonColor: "#d33",
                                        confirmButtonText: "Yes, revert it!",
                                        cancelButtonText: "No, cancel",
                                      }).then((result) => {
                                        if (result.isConfirmed) {
                                          fetchBudgetDetails();
                                          Swal.fire(
                                            "Reverted!",
                                            "Your changes have been reverted.",
                                            "success"
                                          );
                                        }
                                      });
                                    }}
                                    type="button"
                                    className="btn-dim btn btn-secondary"
                                  >
                                    Revert Changes
                                  </Button>
                                </li>
                              </>
                            )}
                          </ul>
                        </div>
                      )}

                      <div
                        onClick={() => handelExcelClick()}
                        className="btn btn-white btn-outline-light"
                        style={{
                          marginLeft: "10px",
                        }}
                      >
                        <Icon name="download-cloud"></Icon>
                        <span>Export </span>
                      </div>

                      {(materialData?.status === "Inactive" ||
                        materialData?.status === "Manually Inactivated") && (
                        <div className="">
                          <ul className="nk-tb-actions ms-2">
                            <li>
                              <Button
                                color="primary"
                                type="button"
                                onClick={handleActivate}
                              >
                                <Icon name="check-circle" />
                                <span>Activate</span>
                              </Button>
                            </li>
                          </ul>
                        </div>
                      )}

                      {!showSubmitBtm && (
                        <div className="paddingLeft10">
                          <Button
                            className="toggle"
                            color="primary"
                            onClick={async () => {
                              navigate("/view-budget");
                            }}
                          >
                            <Icon name="arrow-left" />
                            <span>Back</span>
                          </Button>
                        </div>
                      )}

                      {materialData?.status == "Active" && (
                        <div className="">
                          <ul className="nk-tb-actions ms-2">
                            <li>
                              <UncontrolledDropdown>
                                <DropdownToggle
                                  tag="a"
                                  className="dropdown-toggle btn btn-icon btn-trigger"
                                >
                                  <Icon name="more-v"></Icon>
                                </DropdownToggle>
                                <DropdownMenu end>
                                  <ul className="link-list-opt no-bdr">
                                    <li
                                      onClick={() => {
                                        {
                                          Swal.fire({
                                            title: "Are you sure?",
                                            text: "Do you want to Hold this Budget?",
                                            icon: "warning",
                                            showCancelButton: true,
                                            confirmButtonColor: "#3085d6",
                                            cancelButtonColor: "#d33",
                                            confirmButtonText: "Yes, Hold it!",
                                            cancelButtonText: "No, cancel",
                                          }).then((result) => {
                                            if (result.isConfirmed) {
                                              hold();
                                            } else {
                                              setDisableSubmit(false);
                                            }
                                          });
                                        }
                                      }}
                                    >
                                      <Link to={`#`}>
                                        <Icon
                                          className="text-danger"
                                          name="pause-circle"
                                        ></Icon>
                                        <span>Hold Budget</span>
                                      </Link>
                                    </li>
                                    <li
                                      onClick={() => {
                                        {
                                          Swal.fire({
                                            title: "Are you sure?",
                                            text: "Do you want to Complete this Budget?",
                                            icon: "warning",
                                            showCancelButton: true,
                                            confirmButtonColor: "#3085d6",
                                            cancelButtonColor: "#d33",
                                            confirmButtonText:
                                              "Yes, Complete it!",
                                            cancelButtonText: "No, cancel",
                                          }).then((result) => {
                                            if (result.isConfirmed) {
                                              complete();
                                            } else {
                                              setDisableSubmit(false);
                                            }
                                          });
                                        }
                                      }}
                                    >
                                      <Link to={`#`}>
                                        <Icon
                                          className="text-success"
                                          name="check-circle"
                                        ></Icon>
                                        <span>Complete Budget</span>
                                      </Link>
                                    </li>
                                    <li
                                      onClick={() => {
                                        {
                                          Swal.fire({
                                            title: "Are you sure?",
                                            text: "Do you want to Inactive this Budget?",
                                            icon: "warning",
                                            showCancelButton: true,
                                            confirmButtonColor: "#3085d6",
                                            cancelButtonColor: "#d33",
                                            confirmButtonText:
                                              "Yes, Inactive it!",
                                            cancelButtonText: "No, cancel",
                                          }).then((result) => {
                                            if (result.isConfirmed) {
                                              inactive();
                                            } else {
                                              setDisableSubmit(false);
                                            }
                                          });
                                        }
                                      }}
                                    >
                                      <Link to={`#`}>
                                        <Icon
                                          className="text-warning"
                                          name="cross-circle"
                                        ></Icon>
                                        <span>Inactive Budget</span>
                                      </Link>
                                    </li>
                                  </ul>
                                </DropdownMenu>
                              </UncontrolledDropdown>
                            </li>
                            {/* <li className="pt-0 pb-0">
                                {disableSubmit ? (
                                  <Button color="primary" type="button">
                                    <Spinner size="sm" color="light" />
                                  </Button>
                                ) : (
                                  <Button
                                    color="primary"
                                    type="button"
                                    onClick={() => {
                                      setDisableSubmit(true);
                                      Swal.fire({
                                        title: "Are you sure?",
                                        text: "Do you want to Hold this Budget?",
                                        icon: "warning",
                                        input: "textarea", // This adds the input field for remarks
                                        inputPlaceholder: "Enter your remarks here...",
                                        inputAttributes: {
                                          "aria-label": "Enter your remarks",
                                        },
                                        showCancelButton: true,
                                        confirmButtonColor: "#3085d6",
                                        cancelButtonColor: "#d33",
                                        confirmButtonText: "Yes, Hold it!",
                                        cancelButtonText: "No, cancel",
                                        preConfirm: (remarks) => {
                                          if (!remarks) {
                                            Swal.showValidationMessage("Remarks are required");
                                          }
                                          return remarks;
                                        },
                                      }).then(async (result) => {
                                        if (result.isConfirmed && result.value) {
                                          const remarks = result.value; // Capture the remarks from the Swal input
                                          await hold(remarks); // Pass remarks to the hold API
                                        } else {
                                          setDisableSubmit(false);
                                        }
                                      });
                                    }}
                                  >
                                    Hold
                                  </Button>
                                )}
                              </li>
                              <li className="pt-0 pb-0">
                                <Button
                                  color="secondary"
                                  onClick={() => {
                                    Swal.fire({
                                      title: "Are you sure?",
                                      text: "Do you want to Complete this Budget?",
                                      icon: "warning",
                                      showCancelButton: true,
                                      confirmButtonColor: "#3085d6",
                                      cancelButtonColor: "#d33",
                                      confirmButtonText: "Yes, Complete it!",
                                      cancelButtonText: "No, cancel",
                                    }).then((result) => {
                                      if (result.isConfirmed) {
                                        complete();
                                      } else {
                                        setDisableSubmit(false);
                                      }
                                    });
                                  }}
                                  type="button"
                                  className="btn-dim btn btn-secondary"
                                >
                                  Complete
                                </Button>
                              </li> */}
                          </ul>
                        </div>
                      )}

                      {!showSubmitBtm && materialData?.status == "Yet to be Approved" &&
                        !hasUserAlreadyApproved &&
                        (
                          <>
                            <ul className="nk-tb-actions ms-2">
                              <li>
                                <UncontrolledDropdown>
                                  <DropdownToggle
                                    tag="a"
                                    className="dropdown-toggle btn btn-icon btn-trigger"
                                  >
                                    <Icon name="more-v"></Icon>
                                  </DropdownToggle>
                                  <DropdownMenu end>
                                    <ul className="link-list-opt no-bdr">
                                      {canUserApproveReject() ? (
                                        <>
                                          <li
                                            onClick={(e) => {
                                              e.preventDefault();
                                              setApproveRecord(budgetId);
                                              setActiveSignatureContext("APPROVE");
                                              setIsModalApproveVisible(true);
                                              const dropdown = document.querySelector(
                                                ".dropdown-menu.show"
                                              );
                                              if (dropdown) {
                                                dropdown.classList.remove("show");
                                              }
                                            }}
                                          >
                                            <Link to={`#`}>
                                              <Icon name="check" /> Approve
                                            </Link>
                                          </li>
                                          <li
                                            onClick={(e) => {
                                              e.preventDefault();
                                              setRejectRecord(budgetId);
                                              setActiveSignatureContext("REJECT");
                                              setIsModalRejectedVisible(true);
                                              const dropdown = document.querySelector(
                                                ".dropdown-menu.show"
                                              );
                                              if (dropdown) {
                                                dropdown.classList.remove("show");
                                              }
                                            }}
                                          >
                                            <Link to={`#`}>
                                              <Icon name="cross" /> Reject
                                            </Link>
                                          </li>
                                        </>
                                      ) : (
                                        <>
                                          <li className="disabled" style={{ position: 'relative' }}>
                                            <div
                                              className="d-flex align-items-center justify-content-between w-100"
                                              style={{
                                                padding: "8px 16px",
                                                opacity: 0.6,
                                                cursor: "not-allowed",
                                              }}
                                            >
                                              <div className="d-flex align-items-center" style={{ gap: "8px" }}>
                                                <Icon name="check" />
                                                <span>Approve</span>
                                              </div>
                                              <Popover
                                                content={
                                                  <div style={{ padding: "8px", maxWidth: "300px" }}>
                                                    <p style={{ margin: 0 }}>{getPendingStatusMessage()}</p>
                                                  </div>
                                                }
                                                title="Approval Status"
                                                trigger="hover"
                                              >
                                                <InfoCircleOutlined
                                                  style={{
                                                    fontSize: "16px",
                                                    cursor: "pointer",
                                                    color: "#2263b3",
                                                    marginLeft: "8px"
                                                  }}
                                                />
                                              </Popover>
                                            </div>
                                          </li>
                                          <li className="disabled">
                                            <div
                                              className="d-flex align-items-center"
                                              style={{
                                                padding: "8px 16px",
                                                opacity: 0.6,
                                                cursor: "not-allowed",
                                                gap: "8px"
                                              }}
                                            >
                                              <Icon name="cross" />
                                              <span>Reject</span>
                                            </div>
                                          </li>
                                        </>
                                      )}
                                    </ul>
                                  </DropdownMenu>
                                </UncontrolledDropdown>
                              </li>
                            </ul>
                          </>
                        )
                      }
                    </div>
                    <BlockHeadContent className="align-self-start d-lg-none">
                      <Button
                        className={`toggle btn btn-icon btn-trigger mt-n1 ${sm ? "active" : ""
                          }`}
                        onClick={() => setSm(!sm)}
                      >
                        <Icon name="menu-alt-r" />
                      </Button>
                    </BlockHeadContent>
                  </BlockBetween>
                </BlockHead>
                <div className="content clearfix">
                  <AntCollapse defaultActiveKey={["1", "2", "3"]}>
                    <Panel header="General Information" key="1">
                      {/* Edit icon for non-Active statuses */}
                      {![
                        "Rejected",
                        "Active",
                        "Inactive",
                        "Completed",
                        "Hold",
                        "Manually Inactivated",
                      ].includes(materialData?.status) && (
                          <span
                            className="cursor-pointer position-absolute"
                            style={{
                              right: 43,
                              top: 73,
                              fontSize: "18px",
                              cursor: "pointer",
                            }}
                            onClick={() => {
                              if (tab === "1") {
                                setValue("budgetName", materialData?.budgetName);
                                setValue(
                                  "startDate",
                                  dayjs(materialData?.startDate)
                                );
                                setValue("endDate", dayjs(materialData?.endDate));
                                setValue(
                                  "description",
                                  materialData?.description
                                );
                                setValue("budgetFor", materialData?.budgetFor);
                                setValue("site", materialData?.site);
                                setValue("contractor", materialData?.contractor);
                                setValue("lob", materialData?.lob);
                                setValue(
                                  "approvalRequired",
                                  materialData?.approvalRequired
                                );
                                setValue("costCenter", materialData?.costCenter);
                                setValue("department", materialData?.department);
                              }
                              setGeneralInformationEdit(true);
                            }}
                          >
                            <Icon name="edit" />
                          </span>
                        )}
                      {/* Special edit icon for Active status - only End Date can be edited */}
                      {materialData?.status === "Active" && (
                        <span
                          className="cursor-pointer position-absolute"
                          style={{
                            right: 43,
                            top: 73,
                            fontSize: "18px",
                            cursor: "pointer",
                          }}
                          onClick={() => {
                            if (tab === "1") {
                              setValue("endDate", dayjs(materialData?.endDate));
                            }
                            setExtendForActivate(false);
                            setActiveEndDateEdit(true);
                          }}
                          title="Edit Planned End Date"
                        >
                          <Icon name="edit" />
                        </span>
                      )}
                      {/* Special edit icon for Yet to be Approved status with isActive true - only End Date can be edited */}
                      {materialData?.status === "Yet to be Approved" && materialData?.isActive === true && (
                        <span
                          className="cursor-pointer position-absolute"
                          style={{
                            right: 43,
                            top: 73,
                            fontSize: "18px",
                            cursor: "pointer",
                          }}
                          onClick={() => {
                            if (tab === "1") {
                              setValue("endDate", dayjs(materialData?.endDate));
                            }
                            setExtendForActivate(false);
                            setActiveEndDateEdit(true);
                          }}
                          title="Edit Planned End Date"
                        >
                          <Icon name="edit" />
                        </span>
                      )}
                      <div>
                        <Col className="justify-start w-100  flex-wrap  p-3">
                          <div className="w-35 border-end ">
                            <div className="data-col align-center pt-1 ">
                              <div className="data-label w-30">Budget Name</div>
                              <div className="data-value w-70 ">
                                {materialData?.budgetName}
                              </div>
                            </div>
                            <div className="data-col align-center pt-1 ">
                              <div className="data-label w-30">
                                Planned Start Date
                              </div>
                              <div className="data-value w-70 ">
                                {dayjs(materialData?.startDate).format(
                                  "DD-MMM-YYYY"
                                )}
                              </div>
                            </div>
                            <div className="data-col align-center pt-1">
                              <div className="data-label w-30">
                                Planned End Date
                              </div>
                              <div className="data-value w-70">
                                {dayjs(materialData?.endDate).format(
                                  "DD-MMM-YYYY"
                                )}
                              </div>
                            </div>
                            <div className="data-col align-center pt-1">
                              <div className="data-label w-30">
                                Budget Description
                              </div>
                              <div className="data-value w-70">
                                <Popover
                                  content={
                                    <div>
                                      <p>{materialData?.description}</p>
                                    </div>
                                  }
                                  title={"Description"}
                                >
                                  {materialData?.description?.length > 20 ? (
                                    <span
                                      style={{
                                        color: "#2263b3",
                                        textDecoration: "underline",
                                        cursor: "pointer",
                                      }}
                                    >
                                      {materialData?.description?.substring(
                                        0,
                                        20
                                      )}
                                      ...
                                    </span>
                                  ) : (
                                    materialData?.description
                                  )}
                                </Popover>
                              </div>
                            </div>
                          </div>
                          <div className="w-30 border-end paddingLeft10 ">
                            <div className="data-col align-center pt-1 ">
                              <div className="data-label w-30">Site</div>
                              <div className="data-value w-70 ">
                                {materialData?.siteName}
                              </div>
                            </div>
                            <div className="data-col align-center pt-1 ">
                              <div className="data-label w-30">
                                Line Of Business (LOB)
                              </div>
                              <div className="data-value w-70 ">
                                {materialData?.lob}
                              </div>
                            </div>
                            <div className="data-col align-center pt-1 ">
                              <div className="data-label w-30">Cost Center</div>
                              <div className="data-value w-70 ">
                                {materialData?.costCenterName}
                              </div>
                            </div>
                          </div>
                          <div className="w-35 paddingLeft10">
                            <div className="data-col align-center pt-1 ">
                              <div className="data-label w-30">
                                Approval Required
                              </div>
                              <div className="data-value w-70 ">
                                <ApprovalTimelineContent />
                                {/* {materialData?.approvalRequired
                        ? "Y" && (
                            <>
                              <ApprovalTimelineContent />
                            </>
                          )
                        : "N" && "No"} */}
                              </div>
                            </div>
                          </div>
                        </Col>
                      </div>
                    </Panel>
                    <Panel header="Material Information" key="2">
                      {/* <div className="table-responsive poTable"> */}
                      {/* <div
                            style={{
                              width: screenSize - 380 + "px",
                              margin: "15px auto",
                              // minHeight: "200px",
                            }}
                          > */}

                      <div
                        style={{
                          marginBottom: 16,
                          display: "flex",
                          justifyContent: "flex-end",
                        }}
                      >
                        {[
                          "Yet to be Approved",
                          "Yet to Start",
                          "Active",
                          "Draft",
                        ].includes(materialData?.status) && (
                            <BudgetLineBulkUpload
                              onUpload={handleBudgetLineBulkUpload}
                              budgetCategoryOptions={budgetCategoryOptions}
                              departmentOptions={departmentOptions}
                              budgetStartDate={materialData?.startDate}
                              budgetEndDate={materialData?.endDate}
                              existingLines={data || []}
                              siteId={materialData?.site}
                            />
                          )}
                        {data?.length > 0 && (
                          <>
                            {![
                              "Rejected",
                              "Inactive",
                              "Completed",
                              "Hold",
                              "Manually Inactivated",
                            ].includes(materialData?.status) && (
                                <a href="#add" className="addNewItem">
                                  <Icon name="plus-round" />
                                  <span
                                    onClick={() => {
                                      setAddNewRowModel(true);
                                      setEditLineRow(null);
                                    }}
                                  >
                                    Add New Item
                                  </span>
                                </a>
                              )}
                          </>
                        )}
                      </div>

                      {hasErrors && (
                        <Alert
                          message="Validation Errors Found"
                          description="Some budget lines have validation errors. Please review and fix all errors before proceeding to save changes."
                          type="error"
                          showIcon
                          style={{ marginBottom: 16 }}
                        />
                      )}
                      {data && (
                        <Table
                          className="customTable"
                          columns={filteredColumns}
                          dataSource={data?.map((item: any) => ({
                            ...item,
                            key: item?._rowId || item?.budgetLineName,
                          }))}
                          expandable={{
                            expandedRowKeys,
                            onExpand: handleExpand,
                            rowExpandable: (record: any) => record.bom === "Y",
                            expandedRowRender: (record: any) => {
                              if (record.bom == "Y") {
                                return (
                                  <div>
                                    <div>
                                      <div className="d-flex justify-content-between align-items-center mb-3">
                                        <p style={{ margin: 0 }}>
                                          <strong>BOM Lines</strong>
                                        </p>
                                        {materialData?.status ===
                                          "Yet to be Approved" && (
                                            <BulkBOMUploadDrawer
                                              onUpload={(uploadedBomLines) =>
                                                handleBulkBOMUpload(
                                                  uploadedBomLines,
                                                  record
                                                )
                                              }
                                              materialCategoryOptions={
                                                materialCategoryOptions || []
                                              }
                                              allocation={record.allocation}
                                              budgetValue={
                                                parseFloat(
                                                  record.budgetValue
                                                    ?.toString()
                                                    .replace(/,/g, "")
                                                ) || 0
                                              }
                                              existingBomLines={
                                                record.bomLines || []
                                              }
                                            />
                                          )}
                                      </div>
                                      <div className="mt-3">
                                        <Table
                                          className="customTable"
                                          columns={[
                                            {
                                              title: "Category",
                                              dataIndex: "categoryName",
                                              key: "categoryName",
                                              fixed: "left" as const,
                                              width: 130,
                                            },
                                            {
                                              title: "Material Name",
                                              dataIndex: "materialName",
                                              key: "materialName",
                                              fixed: "left" as const,
                                              width: 130,
                                            },
                                            {
                                              title: "Qty",
                                              dataIndex: "quantity",
                                              key: "quantity",
                                              fixed: "left" as const,
                                              width: 130,
                                            },
                                            {
                                              title: "UOM",
                                              dataIndex: "uomName",
                                              key: "uomName",
                                              width: 130,
                                            },
                                            {
                                              title: "Allocation",
                                              dataIndex: "allocated",
                                              key: "allocated",
                                              width: 130,
                                              render: (text: any) => {
                                                if (
                                                  record.allocation === "value"
                                                ) {
                                                  const value = parseFloat(
                                                    text
                                                      .toString()
                                                      .replace(/,/g, "")
                                                  );

                                                  // Check if the parsed value is a valid number
                                                  if (!isNaN(value)) {
                                                    // Format the value as currency
                                                    return formatCurrency(
                                                      value,
                                                      "INR"
                                                    );
                                                  } else {
                                                    return text; // Return original value if invalid
                                                  }
                                                } else {
                                                  return text + "%";
                                                }
                                              },
                                            },
                                            {
                                              title: "Budget Allocated Qty",
                                              dataIndex: "budgetAllocatedQty",
                                              key: "budgetAllocatedQty",
                                              width: 150,
                                              render: (text: any) =>
                                                text ?? "—",
                                            },
                                          ]}
                                          dataSource={record.bomLines?.map(
                                            (item: any) => ({
                                              ...item,
                                              key: item?.id,
                                            })
                                          )}
                                          scroll={{ x: 1000 }}
                                        />
                                      </div>
                                    </div>
                                  </div>
                                );
                              }
                              return null;
                            },
                          }}
                          locale={{
                            emptyText: (
                              <span
                                style={{
                                  height: "300px",
                                  color: "#333",
                                  fontSize: "16px",
                                }}
                              >
                                Please click on "Add New Item" to add Budget
                                lines.
                              </span>
                            ),
                          }}
                          bordered
                          size="middle"
                          pagination={false}
                        />
                      )}
                      {/* </div> */}

                      {/* </div> */}
                    </Panel>
                    <Panel header="Other Information" key="3">
                      <Descriptions
                        title=""
                        className="custom-description-title"
                      >
                        <Descriptions.Item label="Instructions">
                          <span
                            style={{
                              color: "#2263b3",
                              textDecoration: "underline",
                              cursor: "pointer",
                            }}
                            onClick={() => setInstructionsVisible(true)}
                          >
                            View
                          </span>
                        </Descriptions.Item>
                        <Descriptions.Item label="Terms and Conditions">
                          <span
                            style={{
                              color: "#2263b3",
                              textDecoration: "underline",
                              cursor: "pointer",
                            }}
                            onClick={() => setTermsVisible(true)}
                          >
                            View
                          </span>
                        </Descriptions.Item>
                        {/* {attachments?.length > 0 && ( */}
                        <Descriptions.Item label="">
                          <div>
                            <strong
                              className=""
                              style={{
                                display: "flex",
                                whiteSpace: "nowrap",
                              }}
                            >
                              Attachments &nbsp;
                              <PaperClipOutlined />
                              {attachments?.length === 0 &&
                                newAttachments?.length === 0 && (
                                  <div> : N/A</div>
                                )}
                            </strong>
                            <div>
                              {attachments?.length > 0 &&
                                attachments?.map(
                                  (attachment: any, index: number) => (
                                    <div
                                      key={index}
                                      className="w-100 d-flex justify-content-between"
                                    >
                                      <div>
                                        <strong>{index + 1}.</strong>
                                        &nbsp;
                                        {attachment.name}
                                        &nbsp; &nbsp; &nbsp; &nbsp;
                                      </div>
                                      <div>
                                        <a
                                          href={attachment.link}
                                          download={attachment.link}
                                          target="_blank" // Opens in a new tab
                                          rel="noopener noreferrer" // Adds security
                                          style={{
                                            color: "black",
                                            fontSize: "18px",
                                          }}
                                        >
                                          <DownloadOutlined />
                                        </a>
                                        &nbsp; &nbsp;
                                        {![
                                          "Rejected",
                                          "Active",
                                          "Inactive",
                                          "Completed",
                                          "Hold",
                                          "Manually Inactivated",
                                        ].includes(materialData?.status) && (
                                            <div
                                              style={{
                                                display: "inline",
                                                cursor: "pointer",
                                                color: "red",
                                                fontSize: "16px",
                                              }}
                                              onClick={(e) => {
                                                e.preventDefault(); // Prevent the default anchor behavior
                                                setDeletedAttachments(
                                                  (prev: any) => [
                                                    ...prev,
                                                    { docId: attachment?.docId },
                                                  ]
                                                );
                                                let updatedAttachmentsList =
                                                  attachments?.filter(
                                                    (item: any, i: number) =>
                                                      i !== index
                                                  );
                                                setAttachments(
                                                  updatedAttachmentsList
                                                );
                                                setShowSubmitBtm(true);
                                              }}
                                            >
                                              <DeleteOutlined />
                                            </div>
                                          )}
                                      </div>
                                    </div>
                                  )
                                )}
                              {newAttachments?.map(
                                (attachment: any, index: number) => (
                                  <div
                                    key={index}
                                    className="w-100 d-flex justify-content-between"
                                  >
                                    <div>
                                      <strong>
                                        {attachments?.length + index + 1}.
                                      </strong>
                                      &nbsp;
                                      {attachment.name}
                                      &nbsp; &nbsp; &nbsp; &nbsp;
                                    </div>
                                    <div>
                                      <a
                                        href={attachment.link}
                                        download={attachment.link}
                                        style={{
                                          color: "black",
                                          fontSize: "18px",
                                        }}
                                      >
                                        <DownloadOutlined />
                                      </a>
                                      &nbsp; &nbsp;
                                      <div
                                        style={{
                                          display: "inline",
                                          cursor: "pointer",
                                          color: "red",
                                          fontSize: "16px",
                                        }}
                                        onClick={(e) => {
                                          e.preventDefault(); // Prevent the default anchor behavior
                                          setNewAttachments((prev: any) =>
                                            prev.filter(
                                              (item: any, i: number) =>
                                                i !== index
                                            )
                                          );
                                          setShowSubmitBtm(true);
                                        }}
                                      >
                                        <DeleteOutlined />
                                      </div>
                                    </div>
                                  </div>
                                )
                              )}
                              {![
                                "Rejected",
                                "Active",
                                "Inactive",
                                "Completed",
                                "Hold",
                                "Manually Inactivated",
                              ].includes(materialData?.status) && (
                                  <div className="mt-1">
                                    <Dragger
                                      beforeUpload={beforeUpload}
                                      fileList={[]}
                                      onChange={handleAttachmentChange}
                                    >
                                      <a
                                        onClick={() => { }}
                                        className="addNewItem"
                                      >
                                        <Icon name="plus-round" />
                                        <span>Add Attachment</span>
                                      </a>
                                    </Dragger>
                                  </div>
                                )}
                            </div>
                          </div>
                        </Descriptions.Item>
                        {/* )} */}
                      </Descriptions>
                    </Panel>
                  </AntCollapse>
                </div>
                <MaterialDrawer
                  open={addNewRowModel}
                  onClose={() => {
                    setAddNewRowModel(false);
                    setEditLineRow(null);
                  }}
                  // onSubmit={updateBudgetLines}
                  status={materialData?.orderStatus}
                  formData={{
                    action: editLineRow == null ? "add" : "edit",
                    index: editLineRow?.lineId,
                    item: editLineRow,
                  }}
                  materialCategoryOptions={materialCategoryOptions}
                  appenddata={append}
                  update={(id: any, data: any) => {
                    update(id, data);
                  }}
                  // needByDateType={materialData?.needByDateType}
                  // deliveryAddressType={materialData?.deliveryAddressType}
                  budgetStartDate={materialData?.startDate}
                  budgetEndDate={materialData?.endDate}
                  siteId={materialData?.site}
                  contractorId={materialData?.contractor}
                />
              </div>
            )}
          </div>
        </Card>
      </Content>
      <AntModal
        title={undefined}
        visible={instructionsVisible}
        footer={null}
        onCancel={() => {
          setIsInstructionsChanged(false);
          setInstructionsVisible(false);
        }}
        width="60%"
        bodyStyle={{ maxHeight: "70vh", overflowY: "auto" }}
      >
        <div className="d-flex">
          <h5 className="m-3">Instructions </h5>
          {!isInstructionsChanged &&
            ![
              "Rejected",
              "Active",
              "Inactive",
              "Completed",
              "Hold",
              "Manually Inactivated",
            ].includes(materialData?.status) && (
              <EditOutlined onClick={() => setIsInstructionsChanged(true)} />
            )}
        </div>
        {isInstructionsChanged ? (
          <ReactQuill
            theme="snow"
            value={newInstructions}
            onChange={(data) => {
              setNewInstructions(data);
            }}
            className="mb-3"
          />
        ) : instructions ? (
          <div
            dangerouslySetInnerHTML={{
              __html: instructions || "",
            }}
            className="m-3"
          />
        ) : (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "200px",
            }}
          >
            <Empty description="No Instructions Available for this Budget" />
          </div>
        )}
        {isInstructionsChanged && (
          <ul className="actions clearfix d-flex">
            <li>
              <Button
                color="primary"
                type="submit"
                onClick={() => {
                  setInstructionsVisible(false);
                  setIsInstructionsChanged(true);
                  setShowSubmitBtm(true);
                }}
              >
                Submit
              </Button>
            </li>
            <li className="m-3 mt-0">
              <Button
                color="primary"
                onClick={() => {
                  setIsInstructionsChanged(false);
                  setNewInstructions(instructions);
                }}
                className="btn-dim btn btn-secondary"
              >
                Cancel
              </Button>
            </li>
          </ul>
        )}
      </AntModal>
      <AntModal
        title={undefined}
        visible={termsVisible}
        footer={null}
        onCancel={() => {
          setIsTermsAndConditionsChanged(false);
          setTermsVisible(false);
        }}
        width="60%"
        bodyStyle={{ maxHeight: "70vh", overflowY: "auto" }}
      >
        <div className="d-flex">
          <h5 className="m-3">Terms and Conditions</h5>
          {!isTermsAndConditionsChanged &&
            ![
              "Rejected",
              "Active",
              "Inactive",
              "Completed",
              "Hold",
              "Manually Inactivated",
            ].includes(materialData?.status) && (
              <EditOutlined
                onClick={() => setIsTermsAndConditionsChanged(true)}
              />
            )}
        </div>
        {
          // ["Pending", "Draft", "REQUESTED"].includes(rfqStatus) &&
          isTermsAndConditionsChanged ? (
            <ReactQuill
              theme="snow"
              value={newTermsAndConditions}
              onChange={(data) => {
                setNewTermsAndConditions(data);
              }}
              className="mb-3"
            />
          ) : termsAndConditions ? (
            <div
              dangerouslySetInnerHTML={{
                __html: termsAndConditions || "",
              }}
              className="m-3"
            />
          ) : (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "200px",
              }}
            >
              <Empty description="No Terms and Conditions Available for this Budget" />
            </div>
          )
        }

        {isTermsAndConditionsChanged && (
          <ul className="actions clearfix d-flex">
            <li>
              <Button
                color="primary"
                type="submit"
                onClick={() => {
                  setTermsVisible(false);
                  setIsTermsAndConditionsChanged(true);
                  setShowSubmitBtm(true);
                }}
              >
                Submit
              </Button>
            </li>
            <li className="m-3 mt-0">
              <Button
                color="primary"
                onClick={() => {
                  setIsTermsAndConditionsChanged(false);
                  setNewTermsAndConditions(termsAndConditions);
                }}
                className="btn-dim btn btn-secondary"
              >
                Cancel
              </Button>
            </li>
          </ul>
        )}
      </AntModal>

      <AntModal
        title={
          actionStatus === "Hold"
            ? "Hold Budget"
            : actionStatus === "Complete"
              ? "Complete Budget"
              : "Inactive Budget"
        }
        visible={showActionModelVisible}
        onOk={handleOk} // Ensure form is submitted on OK
        onCancel={handleCancel}
        okText="Submit"
        cancelText="Cancel"
      >
        {actionStatus === "Hold" ? (
          <>
            <Form form={form} layout="vertical" name="rejectForm">
              <Form.Item
                name="reason"
                label="Reason for Hold"
                rules={[
                  { required: true, message: "Please input your reason!" },
                ]}
              >
                <Input.TextArea placeholder="Type your reason here..." />
              </Form.Item>
            </Form>
          </>
        ) : actionStatus === "Complete" ? (
          <Form form={form} layout="vertical" name="completeForm">
            <Form.Item
              name="completionDate"
              label="Completion Date"
              rules={[
                {
                  required: true,
                  message: "Please select the completion date!",
                },
              ]}
            >
              <DatePicker
                style={{ width: "100%" }}
                onChange={(date) => {
                  setCompletedDateSelectedValue(date);
                  form.validateFields(); // Trigger form validation
                }}
              />
            </Form.Item>

            {/* Show "Reason for Delay" if completionDate is after endDate */}
            {completedDateSelectedValue &&
              materialData?.endDate &&
              dayjs(form.getFieldValue("completionDate")).isAfter(
                dayjs(materialData?.endDate)
              ) && (
                <Form.Item
                  name="reasonForDelay"
                  label="Reason for Delay"
                  rules={[
                    {
                      required: true,
                      message: "Please input the reason for delay!",
                    },
                  ]}
                >
                  <Input.TextArea placeholder="Type your reason here..." />
                </Form.Item>
              )}
          </Form>
        ) : (
          <>
            <Form form={form} layout="vertical" name="inactiveForm">
              <Form.Item
                name="inActiveReason"
                label="Reason for Inactive"
                rules={[
                  { required: true, message: "Please input your reason!" },
                ]}
              >
                <Input.TextArea placeholder="Type your reason here..." />
              </Form.Item>
            </Form>
          </>
        )}
      </AntModal>

      <AntModal
        title="Reject Budget"
        visible={isModalRejectedVisible}
        onOk={openRejectConfirmSwal}
        onCancel={handleCancel}
        okText="Submit"
        cancelText="Cancel"
      >
        <Form form={form} layout="vertical" name="rejectForm">
          <Form.Item
            name="reason"
            label="Reason for Rejection"
            rules={[{ required: true, message: "Please input your reason!" }]}
          >
            <Input.TextArea placeholder="Type your reason here..." />
          </Form.Item>
        </Form>
      </AntModal>

      {/* Budget Approval Drawer for Active status with Approval Required = Y */}
      {approvals.open && (
        <BudgetApprovalDrawer
          open={approvals.open}
          siteId={materialData?.site}
          onClose={() => {
            setApprovals((pre) => {
              return {
                ...pre,
                open: false,
              };
            });
          }}
          onSubmit={(approvalData: any) => {
            setApprovals({
              open: false,
              data: approvalData,
            });
            // Mark that changes have been made
            setShowSubmitBtm(true);
          }}
          setApprovalSubmissionStatus={(status: boolean) => { }}
          approvalData={approvals.data}
        />
      )}

      <AntModal
        title="Approve Budget"
        visible={isModalApproveVisible}
        onOk={() => {
          if (!signature.image) {
            Swal.fire({
              icon: "info",
              title: "Signature Required",
              text: "Please add your signature before approving.",
            });
            return;
          }
          openApproveConfirmSwal();
        }}

        onCancel={() => {
          setIsModalApproveVisible(false);
          resetSignature();
        }}
        okText="Submit"
        cancelText="Cancel"
        width={600}
      >
        <div className="p-3">
          <div className="d-flex justify-content-between align-items-center mb-3">
            <span style={{ fontSize: 14, fontWeight: 600 }}>Signature</span>

            {signature.image && (
              <button
                type="button"
                onClick={() =>
                  setSignature({
                    isActive: true,
                    label: "Authorised Signatory",
                    image: null,
                  })
                }
                style={{
                  border: "none",
                  background: "transparent",
                  padding: 0,
                  cursor: "pointer",
                }}
              >
              </button>
            )}
          </div>

          {signature.image ? (
            <>
              <div
                className="border mb-3 d-flex justify-content-center align-items-center"
                style={{
                  padding: 16,
                  borderRadius: 8,
                  background: "#fff",
                }}
              >
                <img
                  src={signature.image}
                  alt="Signed"
                  style={{ maxWidth: 220, maxHeight: 120, objectFit: "contain" }}
                />
              </div>

              <div className="d-flex justify-content-between align-items-center mb-3">
                <Button
                  size="sm"
                  color="outline-secondary"
                  onClick={() =>
                    setSignature({
                      isActive: true,
                      label: "Authorised Signatory",
                      image: null,
                    })
                  }
                >
                  Reset
                </Button>
              </div>
            </>
          ) : (
            <div
              style={{
                width: "100%",
                minHeight: 220,
                border: "2px dashed #dee2e6",
                borderRadius: 8,
                backgroundColor: "#f8f9fa",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                padding: 24,
              }}
            >
              <div
                style={{
                  display: "flex",
                  gap: 12,
                  justifyContent: "center",
                  alignItems: "center",
                  flexWrap: "wrap",
                }}
              >
                <ImageUploadCropper
                  onOpenCrop={() => {
                    setIsModalApproveVisible(false);
                  }}
                  onCloseCrop={() => {
                    if (activeSignatureContext === "APPROVE") {
                      setIsModalApproveVisible(true);
                    } else if (activeSignatureContext === "REJECT") {
                      setIsModalRejectedVisible(true);
                    }
                  }}
                  onSave={(data: string) => {
                    setSignature((prev: any) => ({ ...prev, image: data }));
                  }}
                >
                  <Button
                    color="primary"
                    size="sm"
                    outline
                    style={{ minWidth: 140 }}
                    onClick={() => setActiveSignatureContext("APPROVE")}
                  >
                    <Icon name="upload-cloud" className="me-1" />
                    Upload Image
                  </Button>
                </ImageUploadCropper>

                <Button
                  color="outline-primary"
                  size="sm"
                  style={{ minWidth: 140 }}
                  onClick={() => {
                    setIsModalApproveVisible(false);
                    setShowSignatureModel(true);
                  }}
                >
                  <Icon name="pen" className="me-1" />
                  Signature Pad
                </Button>
              </div>
            </div>
          )}
        </div>
      </AntModal >

      <AntModal
        title="Reject Budget"
        visible={isModalRejectedVisible}
        onOk={openRejectConfirmSwal}
        onCancel={() => {
          setIsModalRejectedVisible(false);
          form.resetFields();
          resetSignature();
        }}
        okText="Submit"
        cancelText="Cancel"
        width={600}
      >
        <Form form={form} layout="vertical" name="rejectForm">
          <Form.Item
            name="reason"
            label="Reason for Rejection"
            rules={[{ required: true, message: "Please input your reason!" }]}
          >
            <Input.TextArea rows={3} placeholder="Type your reason here..." />
          </Form.Item>

          <div className="mt-4">
            <strong style={{ fontSize: "16px" }}>Signature</strong>
          </div>

          {signature.image && (
            <a
              style={{ fontSize: 14, cursor: "pointer" }}
              onClick={() =>
                setSignature({ isActive: true, label: "Authorised Signatory", image: null })
              }
            >
            </a>
          )}


          {signature.image ? (
            <>
              <div className="signatueImgWrapper border mb-3 p-3 text-center">
                <img
                  src={signature.image}
                  alt="Signed"
                  style={{ width: "180px", height: "auto" }}
                />
              </div>
              <div className="d-flex justify-content-end mb-3">
                <Button
                  size="sm"
                  color="outline-secondary"
                  className="me-2"
                  onClick={() =>
                    setSignature({ isActive: true, label: "Authorised Signatory", image: null })
                  }
                >
                  Reset
                </Button>
              </div>

            </>
          ) : (
            <div
              style={{
                minHeight: "200px",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                gap: "15px",
                border: "2px dashed #dee2e6",
                borderRadius: "8px",
                backgroundColor: "#f8f9fa"
              }}
            >
              <div style={{ display: "flex", gap: "10px", flexWrap: "wrap", justifyContent: "center" }}>
                <ImageUploadCropper
                  onOpenCrop={() => {
                    setIsModalRejectedVisible(false);
                  }}
                  onCloseCrop={() => {
                    if (activeSignatureContext === "APPROVE") {
                      setIsModalApproveVisible(true);
                    } else if (activeSignatureContext === "REJECT") {
                      setIsModalRejectedVisible(true);
                    }
                  }}
                  onSave={(data: string) => {
                    setSignature((prev: any) => ({ ...prev, image: data }));
                  }}
                >
                  <Button
                    color="primary"
                    size="sm"
                    outline
                    onClick={() => setActiveSignatureContext("REJECT")}
                  >
                    <Icon name="upload-cloud" className="me-1" />
                    Upload Image
                  </Button>
                </ImageUploadCropper>

                <Button
                  color="outline-primary"
                  size="sm"
                  onClick={() => {
                    setIsModalRejectedVisible(false);
                    setShowSignatureModel(true);
                  }}
                >
                  <Icon name="pen" className="me-1" />
                  Signature Pad
                </Button>
              </div>
            </div>
          )}
        </Form>
      </AntModal>


      {showSignatureModel && (
        <SignatureModal
          modal={showSignatureModel}
          toggle={() => {
            setShowSignatureModel(false);
            if (activeSignatureContext === "APPROVE") {
              setIsModalApproveVisible(true);
            } else if (activeSignatureContext === "REJECT") {
              setIsModalRejectedVisible(true);
            }
          }}
          onSave={(data: string) => {
            setSignature((prev: any) => ({ ...prev, image: data }));
            setShowSignatureModel(false);

            if (activeSignatureContext === "APPROVE") {
              setIsModalApproveVisible(true);
            } else if (activeSignatureContext === "REJECT") {
              setIsModalRejectedVisible(true);
            }
          }}
        />
      )}


    </>
  );
};

export default ViewBudgetDetails;
